<template>
  <div @click="goToBIAnalyticsPage" class="home-button">
    <v-tooltip bottom>
      <template v-slot:activator="{ on }">
        <div v-on="on" class="home-button__icon">
          <svg
              id="Layer_1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
              x="0px"
              y="0px"
              height="256px"
              viewBox="0 0 1080 1080" style="enable-background:new 0 0 1080 1080;" xml:space="preserve">
            <g>
	<path class="st404" d="M227.4,964.5c7.2,0.7,13.4,1.6,17.1,8.4c0.8,1.5,2.3,4.9,2.3,9.7c0,6.9-3.1,13.6-8.7,17.3
		c-1.7,1.1-3.1,1.8-7.1,3.1c1.9,0.3,4.6,0.9,6.3,1.5c10.4,3.9,11,13.5,11,17.1c0,1.3-0.1,3.1-0.7,5.7c-0.3,2.1-1.5,6.6-5.6,10.7
		c-2.1,2.1-4.4,3.6-7,4.6c-4.4,1.7-8.7,1.9-13.5,2.3h-36.2c0.7-7.3,1.4-14.7,1.7-22.1c0.7-11.6,0.9-23.2,1.1-34.7
		c0.1-7.8,0.2-15.6,0.3-23.5H227.4z M202.9,1031.8h14.9c4.7-0.3,8.6-0.6,11.5-4.5c0.9-1.3,2.3-3.4,2.3-7c0-1.5-0.1-5.3-3.4-7.8
		c-3.2-2.5-7.3-2.4-11.6-2.4H204L202.9,1031.8z M204.2,997.8h7.8c6.4-0.1,14.3-0.6,17.1-7c0.2-0.7,0.9-2.3,0.9-4.4
		c0-0.8-0.2-2.9-1.5-4.8c-2.4-3.3-6-3.4-10-3.6h-13.4L204.2,997.8z"/>
              <path class="st404" d="M276,964.8c-0.9,13.6-1.8,27.3-2.5,40.9c-0.7,13.1-1.1,26.1-1.7,39.2h-17.7c1.1-13.8,2.2-27.5,2.9-41.3
		c0.6-13,0.8-25.9,1.1-39L276,964.8z"/>
              <path class="st693" d="M356.7,988.6c-1.1-0.1-2.1-0.3-3.2-0.6c-3.8-0.8-6.8-1.6-10.5-1.6c-2.6,0-7.2,0.6-9.3,2.1
		c-1.6,1.2-2.2,2.7-2.2,4.6c0,2.3,1.1,4.5,2.1,6.6c8,12.3,10,15.2,19.4,26.5c2.5-6.2,2.8-7.7,3.3-14.5l14,0.1c0,0.6,0,3.6-0.3,5.9
		c-0.2,2.1-1.4,8.2-4.9,13.5c-1,1.5-1.5,2-3.5,4.5l7.8,9.1h-16.8l-2-2.6c-6,2.6-7.3,3-13.7,3.8H328c-1.9-0.2-8.9-0.8-14.7-4.3
		c-3-1.7-10.5-7.6-10.5-18.3c0-2.7,0.5-5.1,1.5-7.8c2.7-7.3,8.3-10.6,14.8-14.2c-1.6-3.3-3.2-6.6-3.2-10.1c0-2.7,1.1-8.6,7.5-12.4
		c5.7-3.4,12.1-3.6,18.6-3.7c8,0.4,9.4,0.8,13.9,1.6L356.7,988.6z M325.3,1011.3c-1,0.5-2.5,1.4-3.4,1.9c-4.5,3.5-5,8.3-5,10.2
		c0,4.6,2.3,7.4,3.5,8.5c4.2,4.1,9.8,4.1,11.7,4.1c5.3,0,8-1.4,10.5-2.3L325.3,1011.3z"/>
              <path class="st404" d="M453.4,964.5c1.9,6,4,11.9,6.2,17.9c3,7.8,6.1,15.6,9.1,23.4c4.9,13.1,9.9,26,14.8,39.1h-19
		c-2.6-10-3.6-14-10.4-30.5h-30.7c-3.1,5.7-6.3,11.3-9.3,17.2c-2.2,4.4-4.2,8.8-6.2,13.3h-18l42.1-80.4H453.4z M428.7,1001.9h21.6
		l-9.1-24.9L428.7,1001.9z"/>
              <path class="st693" d="M512.7,976.9c2.5,5.9,5.1,11.9,7.9,17.8c3.2,6.7,6.7,13.4,9.9,20.1c3,6.2,6,12.4,8.9,18.6
		c0.5-7.9,1-15.7,1.5-23.5c0.5-6.7,1-13.4,1.2-20.1c0.2-4.3,0.3-8.6,0.4-13l13.7,0.1c-1.1,12.5-2.1,25-2.9,37.7
		c-0.6,10.1-0.9,20.3-1.2,30.5l-22.6-0.1c-2.7-6.1-5.4-12.3-8.3-18.4c-3-6.1-6.2-12.1-9.1-18.3c-3.2-6.7-6.3-13.5-9.4-20.2
		c-0.6,10-1.2,20-1.8,29.9c-0.3,6-0.7,11.9-0.9,18v9.1l-13.3-0.1c0.8-9.3,1.6-18.7,2.1-28.3c0.3-5.5,0.5-11.1,0.7-16.6
		c0.3-5.1,0.7-10.2,0.8-15.3v-8L512.7,976.9z"/>
              <path class="st693" d="M609.8,976.8c1.7,5,3.4,10.1,5.2,15.1c2.5,6.6,5.1,13.2,7.7,19.8c4.2,11.1,8.3,22,12.5,33.1h-16.1
		c-2.2-8.4-3-11.8-8.8-25.8h-26c-2.6,4.9-5.3,9.6-7.9,14.6c-1.8,3.7-3.6,7.5-5.2,11.3h-15.2l35.6-68.1H609.8z M588.8,1008.5H607
		l-7.7-21.1L588.8,1008.5z"/>
              <path class="st693" d="M656.5,977c-0.7,8.6-1.4,17.4-1.8,26.1c-0.5,10-0.9,20.1-1.3,30.2c5.7,0.2,11.5,0.3,17.1,0.1
		c4.5-0.1,8.9-0.5,13.3-0.9l-0.5,12.3H638c0.5-4.5,1-8.8,1.3-13.3c0.7-9,0.9-18.2,1.3-27.3l0.9-27.4L656.5,977z"/>
              <path class="st693" d="M747.8,976.9l-26,38.4c-0.4,7.1-0.9,14.2-1,21.3v8.6l-15.2-0.1c1.6-12.8,1.8-16.6,2.1-29.6l-22.5-38.6
		l17.4,0.1c1.7,3.9,3.6,7.9,5.6,11.7c2.4,4.7,5,9.1,7.6,13.6c9.6-13.7,11.3-16.9,15.6-25.2H747.8z"/>
              <path class="st693" d="M795.9,977c0,2.1,0,4.3-0.1,6.3c-0.1,1.9-0.3,3.8-0.5,5.7c-3.7-0.2-7.3-0.5-11-0.5c-2.4-0.1-4.9,0-7.3,0
		c-0.6,8.4-1.2,16.9-1.5,25.3c-0.5,10.4-0.8,20.8-1,31.3l-15-0.1c0.7-9.6,1.5-19.3,1.9-29c0.5-9.1,0.8-18.4,1-27.5
		c-4-0.1-8-0.1-11.8,0.1c-2.1,0.1-4.2,0.3-6.3,0.4l0.6-12.1L795.9,977z"/>
              <path class="st693" d="M814.2,977c-0.8,11.6-1.6,23.1-2.1,34.7c-0.6,11.1-1,22.1-1.5,33.2h-15c1-11.7,1.8-23.3,2.4-35
		c0.5-11,0.7-21.9,1-33L814.2,977z"/>
              <path class="st693" d="M875.5,989.6c-7.2-1.6-9.2-2.1-16.5-2.5c-8.4,0.3-15.4,1-20.7,8c-2.1,2.8-5.6,8.8-5.6,17.8
		c0,9.3,4.4,16.8,13.3,20c2.2,0.8,4.4,1.2,9.1,1.6c8.4,0,10.6-0.4,18.4-2.6l-2.4,13.2c-4.2,0.6-6.1,1-13.6,1.3c-1.5,0-3,0.1-4.6,0.1
		c-1.9,0-4.2-0.1-8.2-0.6c-5.1-1.2-9.3-2.1-13.7-5.1c-7.7-5.2-10.3-12.6-11.2-15.6c-1.1-3.9-1.4-8.2-1.5-9.3c0-8.3,0.5-9.8,1.5-14.3
		c1.3-4.1,2.1-6.3,3-8.1c3.5-7,9.8-12.9,17.2-15.6c3.4-1.2,6.2-1.6,9.8-2c8.1-0.4,11.2-0.7,24.9,1.2L875.5,989.6z"/>
              <path class="st693" d="M920.7,989.6c-5.5-1.5-11.3-3.1-17.1-3.1c-5,0-7.2,1.3-8.5,3.2c-0.3,0.4-1.1,1.6-1.1,3.1
		c0,2.6,2.1,4.6,4,6.2c3.6,2.9,7.2,5.8,10.8,8.9c2.8,2.4,5.5,5,8.3,7.5c1.7,1.8,5.7,5.7,5.7,12.6c0,2.6-0.7,8.1-5.9,12.5
		c-4.5,3.8-9.4,4.6-15.1,5.3c-11.2,0.2-13.9-0.3-24.4-3.3l-0.7-13.1c1.6,0.8,3,1.5,4.7,2.1c7,2.9,13.4,3.3,16.3,3.3
		c1.8,0,4.3-0.1,5.9-0.8c1-0.3,4.5-1.7,4.5-5.2c0-2.7-2.1-4.7-4.4-6.7c-2.2-1.9-4.5-3.9-6.7-5.7c-2.2-1.8-4.5-3.6-6.6-5.5
		c-1.5-1.3-2.9-2.7-4.4-4.1c-1.7-1.8-6.5-6.5-6.5-14.2c0-5.1,2.3-10.3,6.8-13.3c1.1-0.7,2.4-1.5,5-2.2c6.5-2,10.3-1.7,13.5-1.7
		c4.6,0.2,6.9,0.2,14.9,1.9L920.7,989.6z"/>
</g>
            <g>
	<g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000040553665599899281200000002152790356163330203_" d="M504.7,654v50.7c0,11,6.2,21.6,15.4,27.3l30.9,17.6
						l90.4-52.5l-30.9-16.8c-9.7-5.7-15.9-15.9-15.9-27.3v-50.7L504.7,654"/>
				</defs>
        <clipPath id="SVGID_00000031890485705033332130000012849661299074191028_">
					<use xlink:href="#SVGID_00000040553665599899281200000002152790356163330203_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000031890485705033332130000012849661299074191028_);">
					<g>
						<g>
							<defs>

									<rect id="SVGID_00000123406308314138437560000005505704473639121548_" x="-217.9" y="-38.5"
                        width="1599.4" height="1065.9"/>
							</defs>
              <clipPath id="SVGID_00000088825217709459516490000004454461297843358649_">
								<use xlink:href="#SVGID_00000123406308314138437560000005505704473639121548_" style="overflow:visible;"/>
							</clipPath>

              <rect x="502.5" y="599.3"
                    style="clip-path:url(#SVGID_00000088825217709459516490000004454461297843358649_);fill:#25292A;"
                    width="141.5" height="152.1"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<defs>
					<path id="SVGID_00000033329436334487012820000014309467057084842175_" d="M279,766.9V732h-0.4l-14.1-8.4V758
						c0,7.1,3.5,13.2,8.8,16.8c0.9,0.4,1.8,1.3,2.6,1.8l13.2,7.5C283.4,780.5,279,774.4,279,766.9"/>
				</defs>
        <clipPath id="SVGID_00000082366744312103323450000003989527800092191924_">
					<use xlink:href="#SVGID_00000033329436334487012820000014309467057084842175_" style="overflow:visible;"/>
				</clipPath>
        <g style="clip-path:url(#SVGID_00000082366744312103323450000003989527800092191924_);">
					<g>
						<g>
							<defs>

									<rect id="SVGID_00000165204525698966130520000014566344776820971173_" x="-217.9" y="-38.5"
                        width="1599.4" height="1065.9"/>
							</defs>
              <clipPath id="SVGID_00000163066090936058992340000011593517228210285709_">
								<use xlink:href="#SVGID_00000165204525698966130520000014566344776820971173_" style="overflow:visible;"/>
							</clipPath>

              <rect x="262.2" y="721.5"
                    style="clip-path:url(#SVGID_00000163066090936058992340000011593517228210285709_);fill:#25292A;"
                    width="29.5" height="65.2"/>
						</g>
					</g>
				</g>
			</g>
		</g>
	</g>
              <g>
		<g>
			<g>
				<g>
					<defs>
						<path id="SVGID_00000052816128783370801240000017949880392934447756_" d="M753.3,116.6c-1.8-1.3-3.1-2.2-5.3-3.1
							c-3.1-1.3-6.6-1.8-10.1-1.3c-1.8,0-3.5,0.4-4.8,1.3l0,0c-0.9,0.4-1.8,0.9-2.6,1.3l-15.9,8.8l0,0l-421,238.5l14.5,8.4
							l436.9-246.9c6.2-3.5,13.7-3.5,19.4-0.4L753.3,116.6"/>
					</defs>
          <clipPath id="SVGID_00000006701808604306225400000000339380215168246941_">
						<use xlink:href="#SVGID_00000052816128783370801240000017949880392934447756_" style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_00000006701808604306225400000000339380215168246941_);">
						<g>
							<g>
								<defs>

										<rect id="SVGID_00000167360421789892403560000012954109532410438309_" x="-217.9" y="-38.5"
                          width="1599.4" height="1065.9"/>
								</defs>
                <clipPath id="SVGID_00000086684917268046648670000000971247924847219338_">
									<use xlink:href="#SVGID_00000167360421789892403560000012954109532410438309_"
                       style="overflow:visible;"/>
								</clipPath>

                <rect x="291.3" y="110"
                      style="clip-path:url(#SVGID_00000086684917268046648670000000971247924847219338_);fill:#25292A;"
                      width="475.7" height="263.2"/>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
                <g>
			<g>
				<g>
					<defs>
						<path id="SVGID_00000009581018465931589130000012416595613483590836_" d="M300.1,375c-13.7,7.9-22,22.5-22,37.9l0.9,318.7
							l496.4-281.7l0.4-308.6c0-7.5-4-13.7-9.7-17.2l0,0l-1.8-0.9c-5.7-3.1-12.8-3.1-19.4,0.4L308,370.6L300.1,375"/>
					</defs>
          <clipPath id="SVGID_00000066508694602286301900000008689411961888641690_">
						<use xlink:href="#SVGID_00000009581018465931589130000012416595613483590836_" style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_00000066508694602286301900000008689411961888641690_);">
						<g>
							<g>
								<defs>

										<rect id="SVGID_00000034793692885285104090000014534418252098685071_" x="-217.9" y="-38.5"
                          width="1599.4" height="1065.9"/>
								</defs>
                <clipPath id="SVGID_00000000941469941125512790000010630066524459685020_">
									<use xlink:href="#SVGID_00000034793692885285104090000014534418252098685071_"
                       style="overflow:visible;"/>
								</clipPath>

                <rect x="275.9" y="117.5"
                      style="clip-path:url(#SVGID_00000000941469941125512790000010630066524459685020_);fill:#E0E1DB;"
                      width="502.1" height="616.3"/>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
                <g>
			<g>
				<g>
					<defs>
						<path id="SVGID_00000017485267078053744170000010039623776543188646_" d="M279,731.6v34.8c0,7.9,4,14.1,10.1,17.6l0.4,0.4l0,0
							c5.7,3.1,13.2,3.5,20.3,0l455.4-258.3c6.2-3.5,10.1-10.6,10.1-17.6v-58.2L279,731.6"/>
					</defs>
          <clipPath id="SVGID_00000111173736722935849090000001978348851577035189_">
						<use xlink:href="#SVGID_00000017485267078053744170000010039623776543188646_" style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_00000111173736722935849090000001978348851577035189_);">
						<g>
							<g>
								<defs>

										<rect id="SVGID_00000029725048761956279760000016073714997578398909_" x="-217.9" y="-38.5"
                          width="1599.4" height="1065.9"/>
								</defs>
                <clipPath id="SVGID_00000074442780392135516150000000632588324192853634_">
									<use xlink:href="#SVGID_00000029725048761956279760000016073714997578398909_"
                       style="overflow:visible;"/>
								</clipPath>

                <rect x="276.7" y="447.7"
                      style="clip-path:url(#SVGID_00000074442780392135516150000000632588324192853634_);fill:#25292A;"
                      width="501.2" height="343"/>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
                <g>
			<g>
				<g>
					<defs>
						<path id="SVGID_00000156548659958288267070000017569909819220891316_" d="M279,731.6l-0.9-318.7c0-15.9,8.4-30.4,22-37.9
							l7.5-4.4l-14.5-8.4l-7.9,4.4c-13.7,7.9-22,22.5-22,37.9l0.9,319.2L279,731.6L279,731.6"/>
					</defs>
          <clipPath id="SVGID_00000046323532960145939570000015359289672704477369_">
						<use xlink:href="#SVGID_00000156548659958288267070000017569909819220891316_" style="overflow:visible;"/>
					</clipPath>
          <g style="clip-path:url(#SVGID_00000046323532960145939570000015359289672704477369_);">
						<g>
							<g>
								<defs>

										<rect id="SVGID_00000027581039347000492380000017353571559559422099_" x="-217.9" y="-38.5"
                          width="1599.4" height="1065.9"/>
								</defs>
                <clipPath id="SVGID_00000063597875921812547600000016599095608252790436_">
									<use xlink:href="#SVGID_00000027581039347000492380000017353571559559422099_"
                       style="overflow:visible;"/>
								</clipPath>

                <rect x="261.3" y="359.5"
                      style="clip-path:url(#SVGID_00000063597875921812547600000016599095608252790436_);fill:#25292A;"
                      width="48.9" height="374.7"/>
							</g>
						</g>
					</g>
				</g>
			</g>
		</g>
                <g id="_x31__00000049221338407463378080000016849216479500971187_">
			<g>
				<g>
					<path class="st737" d="M523.9,314.5c-0.5,0.3-0.9,0.9-0.9,1.3v4.6l-57.8,33.4v-4.6c0-0.5-0.4-0.6-0.9-0.4
						c-0.5,0.3-0.9,0.9-0.9,1.3v4.6l-57.8,33.4v-4.6c0-0.5-0.4-0.6-0.9-0.4c-0.5,0.3-0.9,0.9-0.9,1.3v4.6l-57.8,33.4v-4.6
						c0-0.5-0.4-0.6-0.9-0.4c-0.5,0.3-0.9,0.9-0.9,1.3v4.6l-57.8,33.4v-4.6c0-0.5-0.4-0.6-0.9-0.4c-0.5,0.3-0.9,0.9-0.9,1.3v4.6
						l-57.8,33.4v-4.6c0-0.5-0.4-0.6-0.9-0.4c-0.5,0.3-0.9,0.9-0.9,1.3v4.6l-49.7,28.7l-8.1,4.7v-4.6v-37.5l5.2-3
						c0.5-0.3,0.9-0.9,0.9-1.3c0-0.5-0.4-0.6-0.9-0.4l-5.2,3v-42.1l5.2-3c0.5-0.3,0.9-0.9,0.9-1.3c0-0.5-0.4-0.6-0.9-0.4l-5.2,3
						v-42.1l5.2-3c0.5-0.3,0.9-0.9,0.9-1.3c0-0.5-0.4-0.6-0.9-0.4l-5.2,3v-42.1l5.2-3c0.5-0.3,0.9-0.9,0.9-1.3
						c0-0.5-0.4-0.6-0.9-0.4l-5.2,3v-42.1l5.2-3c0.5-0.3,0.9-0.9,0.9-1.3c0-0.5-0.4-0.6-0.9-0.4l-11.8,6.8c-0.5,0.3-0.9,0.9-0.9,1.3
						c0,0.5,0.4,0.6,0.9,0.4l4.9-2.9v42.1l-4.9,2.9c-0.5,0.3-0.9,0.9-0.9,1.3c0,0.5,0.4,0.6,0.9,0.4l4.9-2.9v42.1l-4.9,2.9
						c-0.5,0.3-0.9,0.9-0.9,1.3c0,0.5,0.4,0.6,0.9,0.4l4.9-2.9v42.1l-4.9,2.9c-0.5,0.3-0.9,0.9-0.9,1.3c0,0.5,0.4,0.6,0.9,0.4
						l4.9-2.9v42.1l-4.9,2.9c-0.5,0.3-0.9,0.9-0.9,1.3c0,0.5,0.4,0.6,0.9,0.4l4.9-2.9v37.5v5.5c0,0.5,0.4,0.6,0.9,0.4l8.9-5.2
						l49.7-28.7v4.9c0,0.5,0.4,0.6,0.9,0.4c0.5-0.3,0.9-0.9,0.9-1.3v-4.9l57.8-33.4v4.9c0,0.5,0.4,0.6,0.9,0.4
						c0.5-0.3,0.9-0.9,0.9-1.3v-4.9l57.8-33.4v4.9c0,0.5,0.4,0.6,0.9,0.4c0.5-0.3,0.9-0.9,0.9-1.3v-4.9l57.8-33.4v4.9
						c0,0.5,0.4,0.6,0.9,0.4c0.5-0.3,0.9-0.9,0.9-1.3v-4.9l57.8-33.4v4.9c0,0.5,0.4,0.6,0.9,0.4c0.5-0.3,0.9-0.9,0.9-1.3v-4.9
						l57.8-33.4v4.9c0,0.5,0.4,0.6,0.9,0.4c0.5-0.3,0.9-0.9,0.9-1.3v-11.2C524.8,314.3,524.4,314.2,523.9,314.5z"/>
          <g>
						<g>
							<g>
								<path class="st737" d="M152.8,538.8c0,0.5-0.1,1-0.3,1.5c-0.2,0.4-0.4,0.9-0.7,1.3c-0.3,0.5-0.8,0.9-1.4,1.2
									c-0.6,0.3-1.1,0.5-1.4,0.4c-0.3-0.1-0.6-0.2-0.7-0.5c-0.2-0.3-0.3-0.7-0.3-1.2v-7.2c0-0.5,0.1-1,0.3-1.5
									c0.2-0.4,0.4-0.9,0.7-1.3c0.3-0.4,0.8-0.9,1.4-1.2c0.6-0.3,1.1-0.4,1.4-0.4c0.3,0.1,0.6,0.3,0.7,0.5
									c0.2,0.3,0.3,0.7,0.3,1.1V538.8z M151,532.6c0-0.3-0.1-0.5-0.2-0.6c-0.1,0-0.2,0-0.4,0.1c-0.3,0.2-0.5,0.5-0.5,0.8
									c-0.1,0.2-0.1,0.3-0.1,0.5v7.2c0,0.4,0.1,0.5,0.3,0.6c0.1,0,0.2,0,0.4-0.1c0.3-0.2,0.5-0.5,0.5-0.8c0.1-0.1,0.1-0.3,0.1-0.5
									V532.6z"/>
							</g>
						</g>
            <g>
							<g>
								<path class="st737" d="M151.1,492.7c0-0.5-0.2-0.8-0.6-0.6c-0.2,0.1-0.4,0.4-0.5,0.6c-0.1,0.3-0.2,0.6-0.2,0.7l-1.5,0.9
									v-6.5l4.4-2.5v1.8l-2.8,1.6v2.6c0.2-0.3,0.4-0.5,0.7-0.8c0.1-0.1,0.3-0.2,0.4-0.3c0.9-0.5,1.4-0.3,1.7,0.1
									c0.3,0.4,0.3,1,0.3,1.2v2.7c0,0.6,0,1.4-0.4,2.2c-0.3,0.9-0.9,1.7-2,2.3c-1.1,0.6-1.7,0.5-2-0.1c-0.3-0.5-0.4-1.4-0.4-2.3
									l1.8-1v0.5c0,0.6,0,1,0.1,1.2c0.1,0.2,0.2,0.2,0.4,0.1c0.2-0.1,0.3-0.3,0.4-0.6c0.1-0.3,0.1-0.7,0.1-1.4V492.7z"/>
							</g>
						</g>
            <g>
							<g>
								<path class="st737" d="M143.7,449.3v-1.2c0.8-0.6,1.2-1.2,1.5-1.7c0.2-0.3,0.3-0.6,0.4-0.9l1.1-0.6v12.3l-1.8,1v-9.6
									L143.7,449.3z"/>
                <path class="st737" d="M152.8,451.2c0,0.5-0.1,1-0.3,1.5c-0.2,0.4-0.4,0.9-0.7,1.3c-0.3,0.5-0.8,0.9-1.4,1.2
									c-0.6,0.3-1.1,0.5-1.4,0.4c-0.3-0.1-0.6-0.2-0.7-0.5c-0.2-0.3-0.3-0.7-0.3-1.2v-7.2c0-0.5,0.1-1,0.3-1.5
									c0.2-0.4,0.4-0.9,0.7-1.3c0.3-0.4,0.8-0.9,1.4-1.2c0.6-0.3,1.1-0.4,1.4-0.4c0.3,0.1,0.6,0.3,0.7,0.5
									c0.2,0.3,0.3,0.7,0.3,1.1V451.2z M151,445c0-0.3-0.1-0.5-0.2-0.6c-0.1,0-0.2,0-0.4,0.1c-0.3,0.2-0.5,0.5-0.5,0.8
									c-0.1,0.2-0.1,0.3-0.1,0.5v7.2c0,0.4,0.1,0.5,0.3,0.6c0.1,0,0.2,0,0.4-0.1c0.3-0.2,0.5-0.5,0.5-0.8c0.1-0.1,0.1-0.3,0.1-0.5
									V445z"/>
							</g>
						</g>
            <g>
							<g>
								<path class="st737" d="M143.9,405.4v-1.2c0.8-0.6,1.2-1.2,1.5-1.7c0.2-0.3,0.3-0.6,0.4-0.9l1.1-0.6v12.3l-1.8,1v-9.6
									L143.9,405.4z"/>
                <path class="st737" d="M151.1,405.1c0-0.5-0.2-0.8-0.6-0.6c-0.2,0.1-0.4,0.4-0.5,0.6c-0.1,0.3-0.2,0.6-0.2,0.7l-1.5,0.9
									v-6.5l4.4-2.5v1.8l-2.8,1.6v2.6c0.2-0.3,0.4-0.5,0.7-0.8c0.1-0.1,0.3-0.2,0.4-0.3c0.9-0.5,1.4-0.3,1.7,0.1
									c0.3,0.4,0.3,1,0.3,1.2v2.7c0,0.6,0,1.4-0.4,2.2c-0.3,0.9-0.9,1.7-2,2.3c-1.1,0.6-1.7,0.5-2-0.1c-0.3-0.5-0.4-1.4-0.4-2.3
									l1.8-1v0.5c0,0.6,0,1,0.1,1.2c0.1,0.2,0.2,0.2,0.4,0.1c0.2-0.1,0.3-0.3,0.4-0.6c0.1-0.3,0.1-0.7,0.1-1.4V405.1z"/>
							</g>
						</g>
            <g>
							<g>
								<path class="st737" d="M141.9,364v-0.9c0-0.8,0.1-1.7,0.5-2.5c0.3-0.8,1-1.5,1.9-2.1c0.9-0.5,1.5-0.5,1.9-0.2
									c0.4,0.3,0.5,1,0.5,1.9c0,1.3-0.5,3-1.1,4.7c-0.6,1.8-1.3,3.4-1.8,4.5l2.9-1.6v1.8l-4.9,2.8v-1.8c0.6-1.2,1.1-2.3,1.5-3.5
									c0.4-1,0.8-2,1-3c0.3-1,0.5-2,0.5-2.7c0-0.3,0-0.7-0.1-0.9c-0.1-0.2-0.2-0.4-0.5-0.2c-0.2,0.1-0.4,0.4-0.5,0.7
									c-0.1,0.3-0.1,0.7-0.1,1.1v0.9L141.9,364z"/>
                <path class="st737" d="M152.8,363.6c0,0.5-0.1,1-0.3,1.5c-0.2,0.4-0.4,0.9-0.7,1.3c-0.3,0.5-0.8,0.9-1.4,1.2
									c-0.6,0.3-1.1,0.5-1.4,0.4c-0.3-0.1-0.6-0.2-0.7-0.5c-0.2-0.3-0.3-0.7-0.3-1.2v-7.2c0-0.5,0.1-1,0.3-1.5
									c0.2-0.4,0.4-0.9,0.7-1.3c0.3-0.4,0.8-0.9,1.4-1.2c0.6-0.3,1.1-0.4,1.4-0.4c0.3,0.1,0.6,0.3,0.7,0.5
									c0.2,0.3,0.3,0.7,0.3,1.1V363.6z M151,357.4c0-0.3-0.1-0.5-0.2-0.6c-0.1,0-0.2,0-0.4,0.1c-0.3,0.2-0.5,0.5-0.5,0.8
									c-0.1,0.2-0.1,0.3-0.1,0.5v7.2c0,0.4,0.1,0.5,0.3,0.6c0.1,0,0.2,0,0.4-0.1c0.3-0.2,0.5-0.5,0.5-0.8c0.1-0.1,0.1-0.3,0.1-0.5
									V357.4z"/>
							</g>
						</g>
            <g>
							<g>
								<path class="st737" d="M142.1,320.1v-0.9c0-0.8,0.1-1.7,0.5-2.5c0.4-0.8,1-1.5,1.9-2.1c0.9-0.5,1.5-0.5,1.9-0.2
									c0.4,0.3,0.5,1,0.5,1.9c0,1.3-0.5,3-1.1,4.7c-0.6,1.8-1.3,3.4-1.8,4.5l2.9-1.6v1.8l-4.9,2.8v-1.8c0.6-1.2,1.1-2.3,1.5-3.5
									c0.4-1,0.8-2,1-3c0.3-1,0.5-2,0.5-2.7c0-0.3,0-0.7-0.1-0.9c-0.1-0.2-0.2-0.4-0.5-0.2c-0.2,0.1-0.4,0.4-0.5,0.7
									c-0.1,0.3-0.1,0.7-0.1,1.1v0.9L142.1,320.1z"/>
                <path class="st737" d="M151.1,317.5c0-0.5-0.2-0.8-0.6-0.6c-0.2,0.1-0.4,0.4-0.5,0.6c-0.1,0.3-0.2,0.6-0.2,0.7l-1.5,0.9
									v-6.5l4.4-2.5v1.8l-2.8,1.6v2.6c0.2-0.3,0.4-0.5,0.7-0.8c0.1-0.1,0.3-0.2,0.4-0.3c0.9-0.5,1.4-0.3,1.7,0.1
									c0.3,0.4,0.3,1,0.3,1.2v2.7c0,0.6,0,1.4-0.4,2.2c-0.3,0.9-0.9,1.7-2,2.3c-1.1,0.6-1.7,0.5-2-0.1c-0.3-0.5-0.4-1.4-0.4-2.3
									l1.8-1v0.5c0,0.6,0,1,0.1,1.2c0.1,0.2,0.2,0.2,0.4,0.1c0.2-0.1,0.3-0.3,0.4-0.6c0.1-0.3,0.1-0.7,0.1-1.4V317.5z"/>
							</g>
						</g>
					</g>
          <g class="st746">
						<g>
							<g>
								<g>
									<path class="st771" d="M196.7,501.8c-0.1,0.1-0.3,0.1-0.4,0.1c-0.4,0-0.6-0.4-0.4-0.9l59.5-157c0.2-0.5,0.7-1,1.1-1.1
										c0.4,0,0.6,0.4,0.4,0.9l-59.5,157C197.3,501.3,197,501.6,196.7,501.8z"/>
								</g>
                <g>
									<path class="st771" d="M315.7,415.6c-0.3,0.2-0.6,0.2-0.7,0l-59.5-70.7c-0.2-0.3-0.1-0.9,0.3-1.3c0.4-0.5,0.9-0.6,1.2-0.3
										l59.5,70.7c0.2,0.3,0.1,0.9-0.3,1.3C316,415.4,315.8,415.5,315.7,415.6z"/>
								</g>
                <g>
									<path class="st771" d="M315.7,415.6c-0.3,0.2-0.6,0.2-0.7,0c-0.2-0.3-0.1-0.9,0.3-1.3l59.5-69.4c0.4-0.5,0.9-0.6,1.2-0.4
										c0.2,0.3,0.1,0.9-0.3,1.3l-59.5,69.4C316,415.4,315.8,415.5,315.7,415.6z"/>
								</g>
                <g>
									<path class="st771" d="M375.2,346.2c-0.1,0.1-0.3,0.1-0.4,0.1c-0.4,0-0.6-0.4-0.3-1l59.5-139.4c0.2-0.5,0.8-1,1.2-1
										c0.4,0,0.6,0.4,0.3,1l-59.5,139.4C375.7,345.7,375.5,346,375.2,346.2z"/>
								</g>
                <g>
									<path class="st771" d="M434.7,206.7c-0.2,0.1-0.5,0.2-0.6,0.1c-0.3-0.2-0.3-0.7,0.1-1.2l59.5-86.9c0.4-0.5,0.9-0.8,1.2-0.6
										c0.3,0.2,0.3,0.7-0.1,1.2l-59.5,86.9C435.1,206.4,434.9,206.6,434.7,206.7z"/>
								</g>
							</g>
						</g>
            <g>
							<g>
								<g>
									<path class="st404" d="M196.7,475.5c-0.2,0.1-0.5,0.2-0.6,0.1c-0.3-0.2-0.3-0.7,0.1-1.2l59.5-86.9c0.4-0.5,0.9-0.8,1.2-0.6
										c0.3,0.2,0.3,0.7-0.1,1.2L197.2,475C197.1,475.2,196.9,475.4,196.7,475.5z"/>
								</g>
                <g>
									<path class="st404" d="M256.2,388.6c-0.2,0.1-0.3,0.1-0.5,0.1c-0.4,0-0.5-0.5-0.2-1.1L315,265.8c0.3-0.5,0.8-0.9,1.2-0.9
										c0.4,0,0.5,0.5,0.2,1.1l-59.5,121.9C256.7,388.2,256.4,388.5,256.2,388.6z"/>
								</g>
                <g>
									<path class="st404" d="M375.2,293.6c-0.2,0.1-0.4,0.2-0.6,0.1l-59.5-27c-0.3-0.1-0.3-0.7,0-1.2c0.3-0.5,0.9-0.8,1.2-0.7
										l59.5,27c0.3,0.1,0.3,0.7,0,1.2C375.6,293.3,375.4,293.5,375.2,293.6z"/>
								</g>
                <g>
									<path class="st404" d="M434.7,276.8c-0.1,0-0.2,0.1-0.2,0.1l-59.5,16.8c-0.5,0.1-0.7-0.2-0.6-0.7c0.1-0.5,0.6-1.1,1.1-1.2
										l59.5-16.8c0.5-0.1,0.7,0.2,0.6,0.7C435.4,276.2,435,276.6,434.7,276.8z"/>
								</g>
                <g>
									<path class="st404" d="M494.2,312.5c-0.2,0.1-0.5,0.2-0.6,0.1L434,276.9c-0.3-0.2-0.3-0.7,0.1-1.3c0.4-0.5,0.9-0.8,1.2-0.6
										l59.5,35.7c0.3,0.2,0.3,0.7-0.1,1.3C494.5,312.2,494.4,312.4,494.2,312.5z"/>
								</g>
							</g>
						</g>
            <g>
							<g>
								<g>
									<path class="st772" d="M196.7,459.6c-0.4,0.2-0.7,0.2-0.8-0.1c-0.1-0.4,0.1-1,0.5-1.4l59.5-53.4c0.5-0.4,0.9-0.4,1.1-0.1
										c0.1,0.4-0.1,1-0.5,1.4l-59.5,53.4C196.9,459.5,196.8,459.5,196.7,459.6z"/>
								</g>
                <g>
									<path class="st772" d="M256.2,406.1c-0.2,0.1-0.4,0.2-0.6,0.1c-0.4-0.1-0.4-0.6-0.1-1.1L315,300.7c0.3-0.5,0.8-0.9,1.2-0.8
										c0.4,0.1,0.4,0.6,0.1,1.1l-59.5,104.4C256.7,405.8,256.4,406,256.2,406.1z"/>
								</g>
                <g>
									<path class="st772" d="M315.7,301.7c-0.2,0.1-0.4,0.2-0.6,0.1c-0.4-0.1-0.4-0.6-0.1-1.1l59.5-104.4
										c0.3-0.5,0.8-0.9,1.2-0.8c0.4,0.1,0.4,0.6,0.1,1.1L316.3,301C316.2,301.3,315.9,301.6,315.7,301.7z"/>
								</g>
                <g>
									<path class="st772" d="M434.7,338.1c-0.4,0.2-0.7,0.2-0.8-0.1l-59.5-140.8c-0.2-0.4,0.1-1,0.5-1.4c0.4-0.4,0.9-0.5,1.1-0.1
										l59.5,140.8c0.2,0.4-0.1,1-0.5,1.4C434.8,338,434.8,338.1,434.7,338.1z"/>
								</g>
                <g>
									<path class="st772" d="M494.2,330c-0.1,0.1-0.2,0.1-0.3,0.1l-59.5,8.1c-0.4,0.1-0.6-0.3-0.4-0.9c0.2-0.5,0.7-1,1.1-1.1
										l59.5-8.1c0.4-0.1,0.6,0.3,0.4,0.9C494.8,329.5,494.5,329.9,494.2,330z"/>
								</g>
							</g>
						</g>
            <g>
							<g>
								<g>
									<path class="st737" d="M196.7,440.5c-0.1,0.1-0.3,0.1-0.4,0.1c-0.4,0-0.6-0.4-0.4-0.9l59.5-148.2c0.2-0.5,0.7-1,1.2-1
										c0.4,0,0.6,0.4,0.4,0.9l-59.5,148.2C197.3,440,197,440.3,196.7,440.5z"/>
								</g>
                <g>
									<path class="st737" d="M315.7,310.5c-0.2,0.1-0.4,0.2-0.6,0.1l-59.5-18.2c-0.4-0.1-0.4-0.6-0.1-1.2
										c0.3-0.5,0.9-0.9,1.2-0.8l59.5,18.2c0.4,0.1,0.4,0.6,0.1,1.2C316.1,310.1,315.9,310.3,315.7,310.5z"/>
								</g>
                <g>
									<path class="st737" d="M375.2,321.2c-0.2,0.1-0.4,0.2-0.5,0.1l-62.5-11.8c-0.4-0.1-0.4-0.6-0.2-1.1
										c0.3-0.5,0.8-0.9,1.2-0.8l62.5,11.8c0.4,0.1,0.4,0.6,0.2,1.1C375.7,320.8,375.4,321.1,375.2,321.2z"/>
								</g>
                <g>
									<path class="st737" d="M375.2,321.2c-0.2,0.1-0.5,0.2-0.6,0.1c-0.3-0.2-0.3-0.7,0.1-1.2l59.5-88.2c0.4-0.5,0.9-0.8,1.2-0.6
										c0.3,0.2,0.3,0.7-0.1,1.2l-59.5,88.2C375.6,320.9,375.4,321.1,375.2,321.2z"/>
								</g>
                <g>
									<path class="st737" d="M434.7,233c-0.3,0.2-0.6,0.2-0.8,0c-0.2-0.3,0-0.9,0.4-1.4l59.5-63.4c0.4-0.4,0.9-0.6,1.1-0.3
										c0.2,0.3,0,0.9-0.4,1.4L435,232.7C434.9,232.8,434.8,233,434.7,233z"/>
								</g>
							</g>
						</g>
            <g>
							<g>
								<g>
									<path class="st702" d="M256.2,458.7c-0.2,0.1-0.5,0.2-0.6,0.1L196,423c-0.3-0.2-0.3-0.7,0.1-1.3c0.4-0.5,0.9-0.8,1.2-0.6
										l59.5,35.7c0.3,0.2,0.3,0.7-0.1,1.3C256.6,458.4,256.4,458.6,256.2,458.7z"/>
								</g>
                <g>
									<path class="st702" d="M256.2,458.7c-0.2,0.1-0.5,0.2-0.6,0.1c-0.3-0.2-0.3-0.7,0.1-1.2l59.5-86.9c0.4-0.5,0.9-0.8,1.2-0.6
										c0.3,0.2,0.3,0.7-0.1,1.2l-59.5,86.9C256.6,458.4,256.4,458.6,256.2,458.7z"/>
								</g>
                <g>
									<path class="st702" d="M375.2,372.5c-0.1,0.1-0.3,0.1-0.4,0.1l-59.5-0.7c-0.4,0-0.5-0.4-0.3-1c0.2-0.5,0.8-1,1.2-1
										l59.5,0.7c0.4,0,0.5,0.4,0.3,1C375.7,372,375.5,372.3,375.2,372.5z"/>
								</g>
                <g>
									<path class="st702" d="M375.2,372.5c-0.2,0.1-0.4,0.2-0.6,0.1c-0.3-0.1-0.3-0.7,0-1.2l82.9-133.7c0.3-0.5,0.9-0.8,1.2-0.7
										c0.3,0.1,0.3,0.7,0,1.2l-82.9,133.7C375.6,372.1,375.4,372.3,375.2,372.5z"/>
								</g>
                <g>
									<path class="st702" d="M458.2,237.8c-0.1,0.1-0.2,0.1-0.3,0.1c-0.4,0.1-0.7-0.3-0.5-0.8l35.9-117.9c0.2-0.5,0.7-1,1.1-1.1
										c0.4-0.1,0.7,0.3,0.5,0.8L459,236.8C458.9,237.2,458.6,237.6,458.2,237.8z"/>
								</g>
							</g>
						</g>
					</g>
          <g>
						<g>
							<g>
								<path class="st771" d="M196.7,495.8c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2
									C191.6,501.1,193.9,497.5,196.7,495.8z"/>
                <path class="st771" d="M256.2,338.9c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2
									C251.1,344.1,253.4,340.5,256.2,338.9z"/>
                <path class="st771" d="M315.7,409.6c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2
									C310.6,414.9,312.8,411.2,315.7,409.6z"/>
                <path class="st771" d="M375.2,340.2c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2
									C370.1,345.5,372.3,341.9,375.2,340.2z"/>
                <path class="st771" d="M434.7,200.8c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2
									C429.6,206,431.8,202.4,434.7,200.8z"/>
                <path class="st771" d="M494.2,113.9c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2
									C489,119.1,491.3,115.5,494.2,113.9z"/>
							</g>
						</g>
            <g>
							<g>
								<path class="st404" d="M196.7,469.6c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1s-5.1,0.7-5.1-2.2
									C191.6,474.8,193.9,471.2,196.7,469.6z"/>
                <path class="st404" d="M256.2,382.7c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2
									C251.1,387.9,253.4,384.3,256.2,382.7z"/>
                <path class="st404" d="M315.7,260.7c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2
									C310.6,266,312.8,262.4,315.7,260.7z"/>
                <path class="st404" d="M375.2,287.7c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2
									C370.1,292.9,372.3,289.3,375.2,287.7z"/>
                <path class="st404" d="M434.7,270.9c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2
									C429.6,276.1,431.8,272.5,434.7,270.9z"/>
                <path class="st404" d="M494.2,306.6c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2
									C489,311.8,491.3,308.2,494.2,306.6z"/>
							</g>
						</g>
            <g>
							<g>
								<path class="st772" d="M196.7,452.4c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1s-5.1,0.7-5.1-2.2
									C191.6,457.7,193.9,454,196.7,452.4z"/>
                <path class="st772" d="M256.2,400.2c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2
									C251.1,405.4,253.4,401.8,256.2,400.2z"/>
                <path class="st772" d="M375.2,191.3c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2
									C370.1,196.6,372.3,193,375.2,191.3z"/>
                <path class="st772" d="M434.7,332.2c2.8-1.6,5.1-0.7,5.1,2.2s-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2
									C429.6,337.4,431.8,333.8,434.7,332.2z"/>
                <path class="st772" d="M494.2,324.1c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2
									C489,329.3,491.3,325.7,494.2,324.1z"/>
							</g>
						</g>
            <g>
							<g>
								<path class="st737" d="M196.7,434.5c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1s-5.1,0.7-5.1-2.2
									C191.6,439.8,193.9,436.2,196.7,434.5z"/>
                <path class="st737" d="M256.2,286.3c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2
									C251.1,291.6,253.4,287.9,256.2,286.3z"/>
                <path class="st737" d="M312,303.8c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2
									C306.9,309,309.2,305.4,312,303.8z"/>
                <path class="st737" d="M375.2,314c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2
									C370.1,319.2,372.3,315.6,375.2,314z"/>
                <path class="st737" d="M434.7,227.1c2.8-1.6,5.1-0.7,5.1,2.2s-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2
									C429.6,232.3,431.8,228.7,434.7,227.1z"/>
                <path class="st737" d="M494.2,163.6c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2
									S491.3,165.2,494.2,163.6z"/>
							</g>
						</g>
            <g>
							<g>
								<path class="st702" d="M196.7,417c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2
									C191.6,422.2,193.9,418.6,196.7,417z"/>
                <path class="st702" d="M256.2,452.7c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2
									C251.1,458,253.4,454.4,256.2,452.7z"/>
                <path class="st702" d="M315.7,365.8c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2
									S312.8,367.5,315.7,365.8z"/>
                <path class="st702" d="M375.2,366.5c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2
									C370.1,371.7,372.3,368.1,375.2,366.5z"/>
                <path class="st702" d="M457.7,231.6c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2
									S454.8,233.3,457.7,231.6z"/>
                <path class="st702" d="M494.2,113.9c2.8-1.6,5.1-0.7,5.1,2.2c0,2.8-2.3,6.4-5.1,8.1c-2.8,1.6-5.1,0.7-5.1-2.2
									C489,119.1,491.3,115.5,494.2,113.9z"/>
							</g>
						</g>
					</g>
				</g>
			</g>
                  <g id="_x31__00000154392146280744819330000000890916025893239190_">
				<g>
					<g>
						<g>
							<polygon class="st697" points="841.3,485.8 353.6,767.4 353.5,439.8 841.2,158.2 							"/>
              <polygon class="st702" points="841.2,174.8 353.5,456.4 353.5,417 841.2,135.4 							"/>
						</g>
            <g>
							<path class="st773" d="M387.2,725.3c-0.3,0-0.6-0.1-0.9-0.2c-0.5-0.3-0.8-0.9-0.8-1.6V594.7c0-1.4,1.1-3.1,2.5-3.9l421-243.1
								c0.8-0.5,1.6-0.5,2.2-0.2c0.5,0.3,0.8,0.9,0.8,1.6v128.7c0,1.4-1.1,3.1-2.5,3.9l-421,243.1
								C388.1,725.1,387.6,725.3,387.2,725.3z M810.3,348.5c-0.2,0-0.5,0.1-0.8,0.3l-421,243.1c-1,0.6-1.9,1.9-1.9,2.9v128.7
								c0,0.2,0,0.5,0.2,0.6c0.2,0.1,0.5,0.1,1-0.2l421-243.1c1-0.6,1.9-1.9,1.9-2.9V349.1c0-0.2,0-0.5-0.2-0.6
								C810.5,348.5,810.4,348.5,810.3,348.5z"/>
						</g>
            <path class="st774" d="M754.9,261.5c-8.1-1.4-16.3,0.6-25.7,5.9c-0.9,0.5-1.9,1.1-2.9,1.7c-10.6,6.7-19.4,15.7-27.6,28.1
							c-8.2,12.4-13.3,24.5-16,37.8c-6.8,33.3,8.5,54.7,34,47.8c4.3-1.2,8.6-3,12.8-5.4c15.8-9.1,30.6-26.7,39.6-48
							C783.5,295.6,777.1,265.2,754.9,261.5z M754.1,326.9c-1.1,2.6-2.4,5.2-3.9,7.9c-5.8,10.1-13.4,17.8-21.1,22.2
							c-2.6,1.5-5.2,2.6-7.8,3.3c-4.9,1.3-9.5,1-13.4-1.2c-7.9-4.5-10.5-15.7-7.8-28.7c1.3-6.4,3.8-13.2,7.7-19.9
							c0.7-1.3,1.5-2.5,2.3-3.7c5-7.6,11.1-13.6,17.2-17.6c0.5-0.3,1.1-0.7,1.6-1c5.7-3.3,11.3-4.7,16.3-3.8
							c1.7,0.3,3.4,0.9,4.9,1.7C760.3,292,761.6,309.2,754.1,326.9z"/>
            <g>
							<g>
								<path class="st750" d="M387.2,488c-0.3,0-0.6-0.1-0.9-0.2c-0.5-0.3-0.8-0.9-0.8-1.6v-26.3c0-1.4,1.1-3.1,2.5-3.9l82.2-47.4
									c0.8-0.5,1.6-0.5,2.2-0.2c0.5,0.3,0.8,0.9,0.8,1.6v26.3c0,1.4-1.1,3.1-2.5,3.9l-82.2,47.4C388.1,487.9,387.6,488,387.2,488z
									 M471.5,409.2c-0.2,0-0.4,0.1-0.8,0.3l-82.2,47.4c-1,0.6-1.9,1.9-1.9,2.9v26.3c0,0.2,0,0.5,0.2,0.6c0.2,0.1,0.5,0.1,1-0.2
									l82.2-47.4c1-0.6,1.9-1.9,1.9-2.9v-26.3c0-0.2,0-0.5-0.2-0.6C471.7,409.3,471.6,409.2,471.5,409.2z"/>
							</g>
              <g>
								<path class="st750" d="M485.4,431.3c-0.3,0-0.6-0.1-0.9-0.2c-0.5-0.3-0.8-0.9-0.8-1.6v-26.3c0-1.4,1.1-3.1,2.5-3.9
									l82.2-47.4c0.8-0.5,1.6-0.5,2.2-0.2c0.5,0.3,0.8,0.9,0.8,1.6v26.3c0,1.4-1.1,3.1-2.5,3.9l-82.2,47.4
									C486.3,431.2,485.8,431.3,485.4,431.3z M569.7,352.5c-0.2,0-0.5,0.1-0.8,0.3l-82.2,47.4c-1,0.6-1.9,1.9-1.9,2.9v26.3
									c0,0.2,0,0.5,0.2,0.6c0.2,0.1,0.5,0.1,1-0.2l82.2-47.4c1-0.6,1.9-1.9,1.9-2.9v-26.3c0-0.2,0-0.5-0.2-0.6
									C569.9,352.5,569.8,352.5,569.7,352.5z"/>
							</g>
              <g>
								<path class="st750" d="M387.2,532.3c-0.3,0-0.6-0.1-0.9-0.2c-0.5-0.3-0.8-0.9-0.8-1.6v-26.3c0-1.4,1.1-3.1,2.5-3.9
									l82.2-47.4c0.8-0.5,1.6-0.5,2.2-0.2c0.5,0.3,0.8,0.9,0.8,1.6v26.3c0,1.4-1.1,3.1-2.5,3.9l-82.2,47.4
									C388.1,532.1,387.6,532.3,387.2,532.3z M471.5,453.5c-0.2,0-0.4,0.1-0.8,0.3l-82.2,47.4c-1,0.6-1.9,1.9-1.9,2.9v26.3
									c0,0.2,0,0.5,0.2,0.6c0.2,0.1,0.5,0.1,1-0.2l82.2-47.4c1-0.6,1.9-1.9,1.9-2.9v-26.3c0-0.2,0-0.5-0.2-0.6
									C471.7,453.5,471.6,453.5,471.5,453.5z"/>
							</g>
              <g>
								<path class="st750" d="M485.4,475.5c-0.3,0-0.6-0.1-0.9-0.2c-0.5-0.3-0.8-0.9-0.8-1.6v-26.3c0-1.4,1.1-3.1,2.5-3.9
									l82.2-47.4c0.8-0.5,1.6-0.5,2.2-0.2c0.5,0.3,0.8,0.9,0.8,1.6v26.3c0,1.4-1.1,3.1-2.5,3.9l-82.2,47.4
									C486.3,475.4,485.8,475.5,485.4,475.5z M569.7,396.8c-0.2,0-0.5,0.1-0.8,0.3l-82.2,47.4c-1,0.6-1.9,1.9-1.9,2.9v26.3
									c0,0.2,0,0.5,0.2,0.6c0.2,0.1,0.5,0.1,1-0.2l82.2-47.4c1-0.6,1.9-1.9,1.9-2.9v-26.3c0-0.2,0-0.5-0.2-0.6
									C569.9,396.8,569.8,396.8,569.7,396.8z"/>
							</g>
              <g>
								<path class="st750" d="M387.2,576.1c-0.3,0-0.6-0.1-0.9-0.2c-0.5-0.3-0.8-0.9-0.8-1.6v-26.3c0-1.4,1.1-3.1,2.5-3.9
									l82.2-47.4c0.8-0.5,1.6-0.5,2.2-0.2c0.5,0.3,0.8,0.9,0.8,1.6v26.3c0,1.4-1.1,3.1-2.5,3.9l-82.2,47.4
									C388.1,576,387.6,576.1,387.2,576.1z M471.5,497.3c-0.2,0-0.5,0.1-0.8,0.3L388.6,545c-1,0.6-1.9,1.9-1.9,2.9v26.3
									c0,0.2,0,0.5,0.2,0.6c0.2,0.1,0.5,0.1,1-0.2l82.2-47.4c1-0.6,1.9-1.9,1.9-2.9V498c0-0.2,0-0.5-0.2-0.6
									C471.7,497.4,471.6,497.3,471.5,497.3z"/>
							</g>
              <g>
								<path class="st750" d="M485.4,519.4c-0.3,0-0.6-0.1-0.9-0.2c-0.5-0.3-0.8-0.9-0.8-1.6v-26.3c0-1.4,1.1-3.1,2.5-3.9
									l82.2-47.4c0.8-0.5,1.6-0.6,2.2-0.2c0.5,0.3,0.8,0.9,0.8,1.6v26.3c0,1.4-1.1,3.1-2.5,3.9L486.8,519
									C486.3,519.3,485.8,519.4,485.4,519.4z M569.7,440.6c-0.2,0-0.5,0.1-0.8,0.3l-82.2,47.4c-1,0.6-1.9,1.9-1.9,2.9v26.3
									c0,0.2,0,0.5,0.2,0.6c0.2,0.1,0.5,0.1,1-0.2l82.2-47.4c1-0.6,1.9-1.9,1.9-2.9v-26.3c0-0.2,0-0.5-0.2-0.6
									C569.9,440.7,569.8,440.6,569.7,440.6z"/>
							</g>
              <g>
								<path class="st750" d="M582.6,375.1c-0.3,0-0.6-0.1-0.9-0.2c-0.5-0.3-0.8-0.9-0.8-1.6V347c0-1.4,1.1-3.1,2.5-3.9l82.2-47.4
									c0.8-0.5,1.6-0.5,2.2-0.2c0.5,0.3,0.8,0.9,0.8,1.6v26.3c0,1.4-1.1,3.1-2.5,3.9L584,374.7C583.6,375,583.1,375.1,582.6,375.1
									z M667,296.4c-0.2,0-0.4,0.1-0.8,0.3L584,344.1c-1,0.6-1.9,1.9-1.9,2.9v26.3c0,0.2,0,0.5,0.2,0.6c0.2,0.1,0.5,0.1,1-0.2
									l82.2-47.4c1-0.6,1.9-1.9,1.9-2.9V297c0-0.2,0-0.5-0.2-0.6C667.2,296.4,667.1,296.4,667,296.4z"/>
							</g>
              <g>
								<path class="st750" d="M582.6,419.4c-0.3,0-0.6-0.1-0.9-0.2c-0.5-0.3-0.8-0.9-0.8-1.6v-26.3c0-1.4,1.1-3.1,2.5-3.9
									l82.2-47.4c0.8-0.5,1.6-0.5,2.2-0.2c0.5,0.3,0.8,0.9,0.8,1.6v26.3c0,1.4-1.1,3.1-2.5,3.9L584,419
									C583.6,419.3,583.1,419.4,582.6,419.4z M667,340.6c-0.2,0-0.4,0.1-0.8,0.3L584,388.3c-1,0.6-1.9,1.9-1.9,2.9v26.3
									c0,0.2,0,0.5,0.2,0.6c0.2,0.1,0.5,0.1,1-0.2l82.2-47.4c1-0.6,1.9-1.9,1.9-2.9v-26.3c0-0.2,0-0.5-0.2-0.6
									C667.2,340.7,667.1,340.6,667,340.6z"/>
							</g>
              <g>
								<path class="st750" d="M582.6,463.3c-0.3,0-0.6-0.1-0.9-0.2c-0.5-0.3-0.8-0.9-0.8-1.6v-26.3c0-1.4,1.1-3.1,2.5-3.9
									l82.2-47.4c0.8-0.5,1.6-0.5,2.2-0.2c0.5,0.3,0.8,0.9,0.8,1.6v26.3c0,1.4-1.1,3.1-2.5,3.9L584,462.9
									C583.6,463.1,583.1,463.3,582.6,463.3z M667,384.5c-0.2,0-0.4,0.1-0.8,0.3L584,432.2c-1,0.6-1.9,1.9-1.9,2.9v26.3
									c0,0.2,0,0.5,0.2,0.6c0.2,0.1,0.5,0.1,1-0.2l82.2-47.4c1-0.6,1.9-1.9,1.9-2.9v-26.3c0-0.2,0-0.5-0.2-0.6
									C667.2,384.5,667.1,384.5,667,384.5z"/>
							</g>
              <g>
								<polygon class="st702" points="405.2,459.9 395,465.8 395,461.2 405.2,455.3 								"/>
                <polygon class="st702" points="434.8,442.8 409.6,457.3 409.6,452.8 434.8,438.2 								"/>
                <polygon class="st702" points="449.1,434.6 439.2,440.3 439.2,435.7 449.1,430 								"/>
                <polygon class="st702" points="416.2,462.1 395,474.3 395,469.7 416.2,457.5 								"/>
                <polygon class="st702" points="427.1,455.8 420.6,459.5 420.6,454.9 427.1,451.2 								"/>
                <polygon class="st702" points="442.8,446.7 431.6,453.2 431.6,448.6 442.8,442.1 								"/>
							</g>
              <g>
								<polygon class="st702" points="502.9,403.5 492.7,409.4 492.7,404.8 502.9,398.9 								"/>
                <polygon class="st702" points="519.6,393.9 507.4,400.9 507.4,396.3 519.6,389.3 								"/>
                <polygon class="st702" points="533.6,385.8 524,391.3 524,386.7 533.6,381.2 								"/>
                <polygon class="st702" points="513.9,405.7 492.7,417.9 492.7,413.3 513.9,401.1 								"/>
                <polygon class="st702" points="529.8,396.5 518.3,403.1 518.3,398.5 529.8,391.9 								"/>
							</g>
              <g>
								<polygon class="st702" points="600.1,347.3 589.9,353.2 589.9,348.6 600.1,342.8 								"/>
                <polygon class="st702" points="629.7,330.3 604.6,344.8 604.6,340.2 629.7,325.7 								"/>
                <polygon class="st702" points="611.1,349.5 589.9,361.8 589.9,357.2 611.1,344.9 								"/>
                <polygon class="st702" points="622.1,343.2 615.6,347 615.6,342.4 622.1,338.6 								"/>
							</g>
              <g>
								<polygon class="st702" points="404.4,504.7 394.2,510.5 394.2,505.9 404.4,500.1 								"/>
                <polygon class="st702" points="434,487.6 408.8,502.1 408.8,497.5 434,483 								"/>
                <polygon class="st702" points="415.4,506.8 394.2,519.1 394.2,514.5 415.4,502.2 								"/>
                <polygon class="st702" points="426.3,500.5 419.8,504.3 419.8,499.7 426.3,495.9 								"/>
							</g>
              <g>
								<polygon class="st702" points="502.9,447.8 492.7,453.6 492.7,449.1 502.9,443.2 								"/>
                <polygon class="st702" points="519.6,438.1 507.4,445.2 507.4,440.6 519.6,433.6 								"/>
                <polygon class="st702" points="533.6,430 524,435.6 524,431 533.6,425.5 								"/>
                <polygon class="st702" points="513.9,449.9 492.7,462.2 492.7,457.6 513.9,445.3 								"/>
                <polygon class="st702" points="529.8,440.8 518.3,447.4 518.3,442.8 529.8,436.2 								"/>
							</g>
              <g>
								<polygon class="st702" points="600.1,391.6 589.9,397.5 589.9,392.9 600.1,387 								"/>
                <polygon class="st702" points="629.7,374.5 604.6,389.1 604.6,384.5 629.7,369.9 								"/>
                <polygon class="st702" points="611.1,393.8 589.9,406 589.9,401.4 611.1,389.2 								"/>
                <polygon class="st702" points="622.1,387.5 615.6,391.2 615.6,386.6 622.1,382.9 								"/>
							</g>
              <g>
								<polygon class="st702" points="403.8,548.8 393.6,554.7 393.6,550.1 403.8,544.2 								"/>
                <polygon class="st702" points="423.6,537.4 408.3,546.2 408.3,541.6 423.6,532.8 								"/>
                <polygon class="st702" points="419,548.6 393.6,563.2 393.6,558.6 419,544 								"/>
							</g>
              <g>
								<polygon class="st702" points="502.9,491.6 492.7,497.5 492.7,492.9 502.9,487 								"/>
                <polygon class="st702" points="519.6,482 507.4,489 507.4,484.4 519.6,477.4 								"/>
                <polygon class="st702" points="533.6,473.9 524,479.4 524,474.8 533.6,469.3 								"/>
                <polygon class="st702" points="513.9,493.8 492.7,506 492.7,501.4 513.9,489.2 								"/>
							</g>
              <g>
								<polygon class="st702" points="600.1,435.5 589.9,441.3 589.9,436.7 600.1,430.9 								"/>
                <polygon class="st702" points="629.7,418.4 604.6,432.9 604.6,428.3 629.7,413.8 								"/>
                <polygon class="st702" points="611.1,437.6 589.9,449.9 589.9,445.3 611.1,433 								"/>
                <polygon class="st702" points="622.1,431.3 615.6,435.1 615.6,430.5 622.1,426.7 								"/>
							</g>
						</g>
            <path class="st773" d="M809.3,348.2l-421,243.1c-1.2,0.7-2.2,2.2-2.2,3.4v20.3l425.3-245.6v-20.3
							C811.4,347.9,810.5,347.5,809.3,348.2z"/>
            <g>
							<g>
								<g class="st417">
									<path class="st775" d="M746.8,339.4c-2.8,2.6-5.7,4.7-8.6,6.4c-2.6,1.5-5.2,2.6-7.8,3.3c-4.9,1.3-9.5,1-13.4-1.2l5.5,3.2
										c3.9,2.2,8.5,2.5,13.4,1.2c2.5-0.7,5.2-1.8,7.8-3.3c2.5-1.4,4.9-3.2,7.3-5.3L746.8,339.4z"/>
                  <path class="st775" d="M738.2,262c-1.3-1.1-2.5-2.2-3.8-3.3c-10.1,6.7-18.6,15.4-26.6,27.4c-8.2,12.4-13.3,24.5-16,37.8
										c-4.5,22.2,0.8,39.1,12.4,45.9l5.5,3.2c-11.6-6.7-16.9-23.7-12.4-45.9c2.7-13.3,7.8-25.4,16-37.8
										c7.7-11.6,15.9-20.2,25.6-26.7C738.8,262.4,738.5,262.2,738.2,262z"/>
                  <path class="st750" d="M769.6,253.5c-8.1-1.4-16.3,0.6-25.7,5.9c-0.9,0.5-1.9,1.1-2.9,1.7c-10.6,6.7-19.4,15.7-27.6,28.1
										c-8.2,12.4-13.3,24.5-16,37.8c-6.8,33.3,8.5,54.7,34,47.8c4.3-1.2,8.6-3,12.8-5.4c15.8-9.1,30.6-26.7,39.6-48
										C798.2,287.7,791.8,257.3,769.6,253.5z M768.8,318.9c-1.1,2.6-2.4,5.2-3.9,7.9c-5.8,10.1-13.4,17.8-21.1,22.2
										c-2.6,1.5-5.2,2.6-7.8,3.3c-4.9,1.3-9.5,1-13.4-1.2c-7.9-4.5-10.5-15.7-7.8-28.7c1.3-6.4,3.8-13.2,7.7-19.9
										c0.7-1.3,1.5-2.5,2.3-3.7c5-7.6,11.1-13.6,17.2-17.6c0.5-0.3,1.1-0.7,1.6-1c5.7-3.3,11.3-4.7,16.3-3.8
										c1.7,0.3,3.4,0.9,4.9,1.7C775,284,776.3,301.2,768.8,318.9z"/>
								</g>
                <g class="st417">
									<path class="st409" d="M770.1,281.3l-10.9-6.3c10.2,5.8,11.6,23.1,4.1,40.7c-1.1,2.6-2.4,5.3-3.9,7.9
										c-5.8,10.1-13.5,17.8-21.1,22.3c-2.6,1.5-5.2,2.6-7.8,3.3l10.9,6.3c2.5-0.7,5.2-1.8,7.8-3.3c7.6-4.4,15.3-12.2,21.1-22.3
										c1.5-2.6,2.8-5.2,3.9-7.9C781.7,304.3,780.3,287.1,770.1,281.3z"/>
                  <polygon class="st402" points="735.9,352.2 731.3,374.8 736.8,378 741.4,355.4 									"/>
                  <path class="st575" d="M775,256.7c-8.1-1.4-16.3,0.5-25.7,5.9c-1,0.6-1.9,1.1-2.9,1.8c-10.5,6.7-19.4,15.7-27.6,28.1
										l11.3,9.5c5-7.6,11.1-13.6,17.2-17.5c0.5-0.3,1.1-0.7,1.6-1c5.7-3.3,11.3-4.7,16.3-3.9c1.7,0.3,3.4,0.8,4.9,1.7
										c10.2,5.8,11.6,23.1,4.1,40.7c-1.1,2.6-2.4,5.3-3.9,7.9c-5.8,10.1-13.5,17.8-21.1,22.3c-2.6,1.5-5.2,2.6-7.8,3.3l-4.6,22.6
										c4.3-1.2,8.6-3,12.8-5.4c15.8-9.1,30.5-26.7,39.6-48C803.5,290.8,797.2,260.4,775,256.7z"/>
								</g>
                <g class="st417">
									<path class="st737" d="M775.5,284.4l-16.3-9.4c10.2,5.8,11.6,23.1,4.1,40.7l16.3,9.4C787.1,307.5,785.7,290.2,775.5,284.4z
										"/>

                  <linearGradient id="SVGID_00000092431611167776883500000013590115239822910618_"
                                  gradientUnits="userSpaceOnUse" x1="736.3436" y1="259.385" x2="788.3403" y2="259.385">
										<stop offset="0" style="stop-color:#166250"/>
                    <stop offset="0.1797" style="stop-color:#196955"/>
                    <stop offset="0.4323" style="stop-color:#237B64"/>
                    <stop offset="0.7265" style="stop-color:#32997C"/>
                    <stop offset="1" style="stop-color:#44BB98"/>
									</linearGradient>
                  <path style="fill:url(#SVGID_00000092431611167776883500000013590115239822910618_);" d="M782.8,259.4
										c-0.1-0.1-0.2-0.1-0.3-0.2l-5.1-2.9c-0.6-0.3-1.1-0.6-1.7-0.9c0.6,0.3,1.3,0.6,1.9,1l-5.5-3.2c-2.4-1.4-5-2.4-8-2.8
										c-8.1-1.4-16.3,0.6-25.7,5.9c-0.7,0.4-1.3,0.8-2,1.2c0.4,0.4,0.9,0.8,1.3,1.2c1,0.9,2.1,1.7,3.1,2.6
										c-0.4,0.2-0.7,0.5-1.1,0.7c3.3,2.3,6.6,4.6,10,7c0.7-0.5,1.4-1,2.1-1.4c1-0.6,2-1.2,2.9-1.8c9.3-5.4,17.6-7.3,25.7-5.9
										c2.9,0.5,5.6,1.5,8,2.8L782.8,259.4z"/>

                  <linearGradient id="SVGID_00000133487192820727124100000017286487337530177706_"
                                  gradientUnits="userSpaceOnUse" x1="724.2114" y1="293.4973" x2="802.2543"
                                  y2="293.4973">
										<stop offset="0" style="stop-color:#166250"/>
                    <stop offset="0.1797" style="stop-color:#196955"/>
                    <stop offset="0.4323" style="stop-color:#237B64"/>
                    <stop offset="0.7265" style="stop-color:#32997C"/>
                    <stop offset="1" style="stop-color:#44BB98"/>
									</linearGradient>
                  <path style="fill:url(#SVGID_00000133487192820727124100000017286487337530177706_);" d="M780.3,259.8
										c-8.1-1.4-16.3,0.5-25.7,5.9c-1,0.6-1.9,1.1-2.9,1.8c-10.5,6.7-19.4,15.7-27.6,28.1l11.3,9.5c5-7.6,11.1-13.6,17.2-17.5
										c0.5-0.3,1.1-0.7,1.6-1c5.7-3.3,11.3-4.7,16.3-3.9c1.7,0.3,3.4,0.8,4.9,1.7c10.2,5.8,11.6,23.1,4.1,40.7l15.1,2.5
										C808.9,293.9,802.5,263.5,780.3,259.8z"/>
								</g>
                <g>

										<linearGradient id="SVGID_00000032646875180783436490000001873297157099379621_"
                                    gradientUnits="userSpaceOnUse" x1="713.2887" y1="297.1159" x2="735.44"
                                    y2="297.1159">
										<stop offset="0" style="stop-color:#166250"/>
                      <stop offset="0.1797" style="stop-color:#196955"/>
                      <stop offset="0.4323" style="stop-color:#237B64"/>
                      <stop offset="0.7265" style="stop-color:#32997C"/>
                      <stop offset="1" style="stop-color:#44BB98"/>
									</linearGradient>
                  <path style="fill:url(#SVGID_00000032646875180783436490000001873297157099379621_);" d="M735.4,305l-11.2-9.4l-5.5-3.2
										c0.1,0.1-5.4-3.1-5.4-3.1l11.3,9.5l5.5,3.2C730.1,301.9,735.4,305,735.4,305L735.4,305z"/>

                  <linearGradient id="SVGID_00000102510786756526954250000009161795559276568450_"
                                  gradientUnits="userSpaceOnUse" x1="707.7973" y1="272.7232" x2="780.3114"
                                  y2="272.7232">
										<stop offset="0" style="stop-color:#166250"/>
                    <stop offset="0.1797" style="stop-color:#196955"/>
                    <stop offset="0.4323" style="stop-color:#237B64"/>
                    <stop offset="0.7265" style="stop-color:#32997C"/>
                    <stop offset="1" style="stop-color:#44BB98"/>
									</linearGradient>
                  <path style="fill:url(#SVGID_00000102510786756526954250000009161795559276568450_);" d="M763.9,250.3
										c-8.1-1.4-16.3,0.5-25.7,5.9c-1,0.6-1.9,1.1-2.9,1.8c-10.5,6.7-19.4,15.7-27.6,28.1l16.4,9.5c8.2-12.4,17-21.4,27.6-28.1
										c1-0.6,2-1.2,2.9-1.8c9.3-5.4,17.6-7.3,25.7-5.9L763.9,250.3z"/>
								</g>
							</g>
              <g>
								<path class="st750" d="M762.3,256.4c-0.2,0-0.4-0.1-0.5-0.3c-0.2-0.3-0.1-0.7,0.2-0.8L856,201l10.6-39.6
									c0-0.2,0.1-0.3,0.3-0.4l70.4-40.6c0.3-0.2,0.7-0.1,0.8,0.2c0.2,0.3,0.1,0.7-0.2,0.8l-70.1,40.5l-10.6,39.6
									c0,0.2-0.1,0.3-0.3,0.4l-94.2,54.4C762.5,256.4,762.4,256.4,762.3,256.4z"/>
							</g>
              <g>
								<path class="st750" d="M796.9,288c-0.2,0-0.4-0.1-0.5-0.3c-0.2-0.3-0.1-0.7,0.2-0.8l59.6-34.4l4.1-15.1
									c0-0.2,0.1-0.3,0.3-0.4l44.9-25.9c0.3-0.2,0.7-0.1,0.8,0.2c0.2,0.3,0.1,0.7-0.2,0.8l-44.7,25.8l-4.1,15.1
									c0,0.2-0.1,0.3-0.3,0.4l-59.8,34.5C797.1,288,797,288,796.9,288z"/>
							</g>
              <g>
								<path class="st750" d="M759.2,356c-0.2,0-0.4-0.1-0.5-0.3c-0.2-0.3-0.1-0.7,0.2-0.8l71.4-41.2c0.1-0.1,0.3-0.1,0.5-0.1
									l25.3,6.8l43.6-25.1c0.3-0.2,0.7-0.1,0.8,0.2c0.2,0.3,0.1,0.7-0.2,0.8l-43.8,25.3c-0.1,0.1-0.3,0.1-0.5,0.1l-25.3-6.8
									L759.5,356C759.4,356,759.3,356,759.2,356z"/>
							</g>
              <g>
								<polygon class="st702" points="878,139.3 866.6,145.8 866.6,140.7 878,134.2 								"/>
                <polygon class="st702" points="910.9,120.3 882.9,136.4 882.9,131.3 910.9,115.2 								"/>
                <polygon class="st702" points="926.8,111.1 915.8,117.4 915.8,112.3 926.8,106 								"/>
                <polygon class="st702" points="890.2,141.7 866.6,155.3 866.6,150.2 890.2,136.6 								"/>
                <polygon class="st702" points="902.4,134.6 895.1,138.8 895.1,133.7 902.4,129.5 								"/>
                <polygon class="st702" points="919.8,124.6 907.3,131.8 907.3,126.7 919.8,119.5 								"/>
							</g>
              <g>
								<polygon class="st702" points="871.5,215.3 860.2,221.8 860.2,216.7 871.5,210.2 								"/>
                <polygon class="st702" points="890,204.6 876.5,212.4 876.5,207.3 890,199.5 								"/>
                <polygon class="st702" points="905.6,195.6 895,201.7 895,196.6 905.6,190.5 								"/>
                <polygon class="st702" points="883.7,217.7 860.2,231.3 860.2,226.2 883.7,212.6 								"/>
                <polygon class="st702" points="901.3,207.5 888.7,214.8 888.7,209.7 901.3,202.4 								"/>
							</g>
              <g>
								<polygon class="st702" points="867.6,298.5 856.3,305.1 856.3,300 867.6,293.4 								"/>
                <polygon class="st702" points="900.5,279.5 872.6,295.7 872.6,290.6 900.5,274.4 								"/>
                <polygon class="st702" points="879.8,300.9 856.3,314.5 856.3,309.4 879.8,295.8 								"/>
                <polygon class="st702" points="892,293.9 884.8,298.1 884.8,293 892,288.8 								"/>
							</g>
						</g>
            <path class="st780" d="M353.6,767.4l66.1-38.1l-54.5-76.5c-0.8-1.2-2.3-1.2-3.7-0.3c-1.4,0.8-2.9,2.5-3.7,4.6l-4.2,10.9
							L353.6,767.4z"/>
            <path class="st781" d="M730.2,423.9c0.3-0.2,0.6-0.2,0.7,0.1l11.2,15.7c0.3,0.5-0.1,1.5-0.7,1.8l-22.2,12.8
							c-0.6,0.4-1-0.2-0.7-1l11.1-28.5C729.7,424.4,730,424.1,730.2,423.9z M729.5,459.4L718.5,488c-0.3,0.8,0.1,1.4,0.7,1
							l22.2-12.8c0.6-0.4,1-1.4,0.7-1.8L731,458.6c-0.2-0.2-0.4-0.2-0.7-0.1C730,458.7,729.7,459,729.5,459.4z M729.5,494.1
							l-11.1,28.5c-0.3,0.8,0.1,1.4,0.7,1l22.2-12.8c0.6-0.4,1-1.4,0.7-1.8L731,493.2c-0.2-0.2-0.4-0.2-0.7-0.1
							C730,493.3,729.7,493.7,729.5,494.1z"/>
            <g>
							<g>
								<polygon class="st773" points="415.5,615.4 404.7,621.7 404.7,616.8 415.5,610.6 								"/>
                <polygon class="st773" points="446.7,597.4 420.2,612.7 420.2,607.9 446.7,592.6 								"/>
                <polygon class="st773" points="461.8,588.7 451.4,594.7 451.4,589.9 461.8,583.8 								"/>
                <polygon class="st773" points="427,617.7 404.7,630.6 404.7,625.8 427,612.9 								"/>
                <polygon class="st773" points="438.6,611.1 431.7,615 431.7,610.2 438.6,606.2 								"/>
                <polygon class="st773" points="455.2,601.5 443.3,608.3 443.3,603.5 455.2,596.6 								"/>
							</g>
              <g>
								<polygon class="st773" points="494.3,569.9 483.5,576.1 483.5,571.3 494.3,565.1 								"/>
                <polygon class="st773" points="525.5,551.9 499,567.2 499,562.4 525.5,547 								"/>
                <polygon class="st773" points="505.9,572.2 483.5,585.1 483.5,580.3 505.9,567.4 								"/>
                <polygon class="st773" points="517.5,565.5 510.6,569.5 510.6,564.7 517.5,560.7 								"/>
							</g>
              <g>
								<polygon class="st773" points="573.9,524 563.2,530.2 563.2,525.3 573.9,519.1 								"/>
                <polygon class="st773" points="605.2,505.9 578.6,521.2 578.6,516.4 605.2,501.1 								"/>
                <polygon class="st773" points="609.9,498.4 609.9,503.2 620.3,497.2 620.3,492.3 								"/>
                <polygon class="st773" points="585.5,526.2 563.2,539.2 563.2,534.3 585.5,521.4 								"/>
                <polygon class="st773" points="597.1,519.6 590.2,523.5 590.2,518.7 597.1,514.7 								"/>
							</g>
              <g>
								<polygon class="st773" points="415.5,646.9 404.7,653.1 404.7,648.2 415.5,642 								"/>
                <polygon class="st773" points="439,633.3 420.2,644.2 420.2,639.3 439,628.4 								"/>
                <polygon class="st773" points="456.2,623.4 443.7,630.6 443.7,625.7 456.2,618.5 								"/>
                <polygon class="st773" points="427,649.2 404.7,662.1 404.7,657.2 427,644.3 								"/>
                <polygon class="st773" points="449.9,636 431.7,646.5 431.7,641.6 449.9,631.1 								"/>
							</g>
              <g>
								<polygon class="st773" points="494.3,601.3 483.5,607.6 483.5,602.7 494.3,596.5 								"/>
                <polygon class="st773" points="510.8,591.8 499,598.6 499,593.8 510.8,587 								"/>
                <polygon class="st773" points="505.9,603.6 483.5,616.6 483.5,611.7 505.9,598.8 								"/>
							</g>
              <g>
								<polygon class="st773" points="573.9,555.4 563.2,561.6 563.2,556.7 573.9,550.5 								"/>
                <polygon class="st773" points="595.8,542.8 578.6,552.7 578.6,547.8 595.8,537.9 								"/>
                <polygon class="st773" points="613.7,532.4 600.6,540 600.6,535.1 613.7,527.6 								"/>
                <polygon class="st773" points="585.5,557.7 563.2,570.6 563.2,565.7 585.5,552.8 								"/>
							</g>
              <g>
								<polygon class="st773" points="415.5,678.3 404.7,684.5 404.7,679.6 415.5,673.4 								"/>
                <polygon class="st773" points="446.7,660.2 420.2,675.6 420.2,670.7 446.7,655.4 								"/>
                <polygon class="st773" points="427,680.6 404.7,693.5 404.7,688.6 427,675.7 								"/>
                <polygon class="st773" points="438.6,673.9 431.7,677.9 431.7,673 438.6,669 								"/>
							</g>
              <g>
								<polygon class="st773" points="494.3,632.8 483.5,639 483.5,634.1 494.3,627.9 								"/>
                <polygon class="st773" points="525.5,614.7 499,630.1 499,625.2 525.5,609.9 								"/>
                <polygon class="st773" points="540.6,606 530.2,612 530.2,607.2 540.6,601.2 								"/>
                <polygon class="st773" points="505.9,635.1 483.5,648 483.5,643.1 505.9,630.2 								"/>
                <polygon class="st773" points="517.5,628.4 510.6,632.4 510.6,627.5 517.5,623.5 								"/>
							</g>
              <g>
								<polygon class="st773" points="573.9,586.8 563.2,593 563.2,588.2 573.9,581.9 								"/>
                <polygon class="st773" points="605.2,568.8 578.6,584.1 578.6,579.2 605.2,563.9 								"/>
                <polygon class="st773" points="585.5,589.1 563.2,602 563.2,597.1 585.5,584.2 								"/>
                <polygon class="st773" points="597.1,582.4 590.2,586.4 590.2,581.5 597.1,577.5 								"/>
							</g>
              <g>
								<g>
									<g>
										<polygon class="st773" points="643.6,481 639,483.6 639,481.6 643.6,479 										"/>
                    <polygon class="st773"
                             points="658.5,472.4 645.5,479.9 645.5,477.9 658.5,470.4 										"/>
                    <polygon class="st773"
                             points="664.8,468.8 660.4,471.3 660.4,469.3 664.8,466.7 										"/>
                    <polygon class="st773" points="648.4,482 639,487.4 639,485.4 648.4,480 										"/>
                    <polygon class="st773"
                             points="653.3,479.2 650.4,480.9 650.4,478.8 653.3,477.1 										"/>
                    <polygon class="st773" points="662,474.1 655.3,478 655.3,476 662,472.1 										"/>
									</g>
                  <g>
										<polygon class="st773"
                             points="669.8,465.9 667.1,467.5 667.1,465.4 669.8,463.8 										"/>
                    <polygon class="st773" points="683,458.3 671.8,464.7 671.8,462.7 683,456.3 										"/>
                    <polygon class="st773"
                             points="674.7,466.8 664.2,472.9 664.2,470.9 674.7,464.8 										"/>
                    <polygon class="st773" points="679.6,464 676.7,465.7 676.7,463.7 679.6,462 										"/>
									</g>
                  <g>
										<polygon class="st773"
                             points="690.2,454.1 685.6,456.7 685.6,454.7 690.2,452.1 										"/>
                    <polygon class="st773" points="703.3,446.6 692.1,453 692.1,451 703.3,444.5 										"/>
                    <polygon class="st773"
                             points="705.3,443.4 705.3,445.4 709.6,442.9 709.6,440.8 										"/>
                    <polygon class="st773" points="695,455.1 682,462.6 682,460.6 695,453.1 										"/>
                    <polygon class="st773" points="699.9,452.3 697,454 697,451.9 699.9,450.2 										"/>
									</g>
								</g>
                <g>
									<g>
										<polygon class="st773" points="643.6,489 639,491.6 639,489.5 643.6,486.9 										"/>
                    <polygon class="st773"
                             points="658.5,480.4 645.5,487.8 645.5,485.8 658.5,478.3 										"/>
                    <polygon class="st773"
                             points="664.8,476.7 660.4,479.2 660.4,477.2 664.8,474.7 										"/>
                    <polygon class="st773" points="648.4,489.9 639,495.3 639,493.3 648.4,487.9 										"/>
                    <polygon class="st773"
                             points="653.3,487.1 650.4,488.8 650.4,486.7 653.3,485.1 										"/>
                    <polygon class="st773" points="662,482.1 655.3,486 655.3,483.9 662,480 										"/>
									</g>
                  <g>
										<polygon class="st773"
                             points="669.8,473.8 667.1,475.4 667.1,473.4 669.8,471.8 										"/>
                    <polygon class="st773" points="683,466.2 671.8,472.7 671.8,470.6 683,464.2 										"/>
                    <polygon class="st773"
                             points="674.7,474.8 664.2,480.8 664.2,478.8 674.7,472.7 										"/>
                    <polygon class="st773" points="679.6,472 676.7,473.6 676.7,471.6 679.6,469.9 										"/>
									</g>
                  <g>
										<polygon class="st773" points="690.2,462.1 685.6,464.7 685.6,462.6 690.2,460 										"/>
									</g>
								</g>
							</g>
              <g>
								<g>
									<g>
										<polygon class="st773" points="643.6,512.4 639,515 639,513 643.6,510.4 										"/>
                    <polygon class="st773"
                             points="658.5,503.8 645.5,511.3 645.5,509.2 658.5,501.8 										"/>
                    <polygon class="st773"
                             points="664.8,500.1 660.4,502.7 660.4,500.6 664.8,498.1 										"/>
                    <polygon class="st773" points="648.4,513.4 639,518.8 639,516.7 648.4,511.3 										"/>
                    <polygon class="st773"
                             points="653.3,510.6 650.4,512.2 650.4,510.2 653.3,508.5 										"/>
                    <polygon class="st773" points="662,505.5 655.3,509.4 655.3,507.4 662,503.5 										"/>
									</g>
                  <g>
										<polygon class="st773"
                             points="669.8,497.2 667.1,498.8 667.1,496.8 669.8,495.2 										"/>
                    <polygon class="st773" points="683,489.7 671.8,496.1 671.8,494.1 683,487.6 										"/>
                    <polygon class="st773"
                             points="674.7,498.2 664.2,504.3 664.2,502.2 674.7,496.2 										"/>
                    <polygon class="st773" points="679.6,495.4 676.7,497.1 676.7,495 679.6,493.4 										"/>
									</g>
                  <g>
										<polygon class="st773"
                             points="690.2,485.5 685.6,488.1 685.6,486.1 690.2,483.5 										"/>
                    <polygon class="st773"
                             points="703.3,477.9 692.1,484.4 692.1,482.3 703.3,475.9 										"/>
                    <polygon class="st773"
                             points="705.3,474.7 705.3,476.8 709.6,474.3 709.6,472.2 										"/>
                    <polygon class="st773" points="695,486.5 682,494 682,492 695,484.4 										"/>
                    <polygon class="st773" points="699.9,483.6 697,485.3 697,483.3 699.9,481.6 										"/>
									</g>
								</g>
                <g>
									<g>
										<polygon class="st773" points="643.6,520.3 639,522.9 639,520.9 643.6,518.3 										"/>
                    <polygon class="st773"
                             points="658.5,511.7 645.5,519.2 645.5,517.1 658.5,509.7 										"/>
                    <polygon class="st773" points="664.8,508.1 660.4,510.6 660.4,508.5 664.8,506 										"/>
									</g>
                  <g>
										<polygon class="st773"
                             points="669.8,505.2 667.1,506.8 667.1,504.7 669.8,503.1 										"/>
                    <polygon class="st773" points="683,497.6 671.8,504 671.8,502 683,495.5 										"/>
                    <polygon class="st773" points="704,485.4 692.9,491.9 692.9,489.8 704,483.4 										"/>
									</g>
                  <g>
										<polygon class="st773" points="690.2,493.4 685.6,496 685.6,494 690.2,491.4 										"/>
									</g>
								</g>
							</g>
              <g>
								<g>
									<g>
										<polygon class="st773" points="643.6,544 639,546.6 639,544.6 643.6,542 										"/>
                    <polygon class="st773"
                             points="658.5,535.4 645.5,542.9 645.5,540.8 658.5,533.4 										"/>
                    <polygon class="st773"
                             points="664.8,531.7 660.4,534.3 660.4,532.2 664.8,529.7 										"/>
                    <polygon class="st773" points="648.4,545 639,550.4 639,548.3 648.4,542.9 										"/>
                    <polygon class="st773"
                             points="653.3,542.1 650.4,543.8 650.4,541.8 653.3,540.1 										"/>
                    <polygon class="st773" points="662,537.1 655.3,541 655.3,539 662,535.1 										"/>
									</g>
                  <g>
										<polygon class="st773"
                             points="669.8,528.8 667.1,530.4 667.1,528.4 669.8,526.8 										"/>
                    <polygon class="st773" points="683,521.3 671.8,527.7 671.8,525.7 683,519.2 										"/>
                    <polygon class="st773"
                             points="674.7,529.8 664.2,535.8 664.2,533.8 674.7,527.8 										"/>
                    <polygon class="st773" points="679.6,527 676.7,528.7 676.7,526.6 679.6,524.9 										"/>
									</g>
                  <g>
										<polygon class="st773"
                             points="690.2,517.1 685.6,519.7 685.6,517.7 690.2,515.1 										"/>
                    <polygon class="st773" points="703.3,509.5 692.1,516 692.1,513.9 703.3,507.5 										"/>
                    <polygon class="st773"
                             points="705.3,506.3 705.3,508.4 709.6,505.8 709.6,503.8 										"/>
                    <polygon class="st773" points="695,518.1 682,525.6 682,523.6 695,516 										"/>
                    <polygon class="st773" points="707.5,510.8 697,516.9 697,514.9 707.5,508.8 										"/>
									</g>
								</g>
                <g>
									<g>
										<polygon class="st773" points="643.6,551.9 639,554.5 639,552.5 643.6,549.9 										"/>
                    <polygon class="st773"
                             points="658.5,543.3 645.5,550.8 645.5,548.7 658.5,541.3 										"/>
                    <polygon class="st773"
                             points="664.8,539.7 660.4,542.2 660.4,540.1 664.8,537.6 										"/>
                    <polygon class="st773" points="648.4,552.9 639,558.3 639,556.3 648.4,550.9 										"/>
                    <polygon class="st773" points="653.3,550.1 650.4,551.7 650.4,549.7 653.3,548 										"/>
                    <polygon class="st773" points="662,545 655.3,548.9 655.3,546.9 662,543 										"/>
									</g>
                  <g>
										<polygon class="st773"
                             points="669.8,536.8 667.1,538.4 667.1,536.3 669.8,534.7 										"/>
                    <polygon class="st773" points="683,529.2 671.8,535.6 671.8,533.6 683,527.1 										"/>
									</g>
                  <g>
										<polygon class="st773" points="690.2,525 685.6,527.6 685.6,525.6 690.2,523 										"/>
									</g>
								</g>
							</g>
              <g>
								<g>
									<g>
										<polygon class="st773"
                             points="758.8,414.5 754.3,417.1 754.3,415.1 758.8,412.5 										"/>
                    <polygon class="st773"
                             points="773.7,405.9 760.8,413.4 760.8,411.3 773.7,403.9 										"/>
                    <polygon class="st773" points="780,402.2 775.7,404.8 775.7,402.7 780,400.2 										"/>
                    <polygon class="st773"
                             points="763.7,415.5 754.3,420.9 754.3,418.8 763.7,413.4 										"/>
                    <polygon class="st773"
                             points="768.5,412.7 765.6,414.3 765.6,412.3 768.5,410.6 										"/>
                    <polygon class="st773"
                             points="777.3,407.6 770.5,411.5 770.5,409.5 777.3,405.6 										"/>
									</g>
                  <g>
										<polygon class="st773"
                             points="785.1,399.3 782.3,400.9 782.3,398.9 785.1,397.3 										"/>
									</g>
								</g>
                <g>
									<g>
										<polygon class="st773" points="758.8,422.4 754.3,425 754.3,423 758.8,420.4 										"/>
                    <polygon class="st773"
                             points="773.7,413.8 760.8,421.3 760.8,419.3 773.7,411.8 										"/>
                    <polygon class="st773" points="780,410.2 775.7,412.7 775.7,410.7 780,408.1 										"/>
                    <polygon class="st773"
                             points="763.7,423.4 754.3,428.8 754.3,426.8 763.7,421.4 										"/>
                    <polygon class="st773"
                             points="768.5,420.6 765.6,422.3 765.6,420.2 768.5,418.5 										"/>
                    <polygon class="st773"
                             points="777.3,415.5 770.5,419.4 770.5,417.4 777.3,413.5 										"/>
									</g>
								</g>
							</g>
              <g>
								<g>
									<g>
										<polygon class="st773"
                             points="758.8,445.9 754.3,448.5 754.3,446.4 758.8,443.8 										"/>
                    <polygon class="st773"
                             points="773.7,437.3 760.8,444.7 760.8,442.7 773.7,435.2 										"/>
                    <polygon class="st773" points="780,433.6 775.7,436.1 775.7,434.1 780,431.6 										"/>
                    <polygon class="st773"
                             points="763.7,446.8 754.3,452.3 754.3,450.2 763.7,444.8 										"/>
                    <polygon class="st773" points="768.5,444 765.6,445.7 765.6,443.7 768.5,442 										"/>
                    <polygon class="st773" points="777.3,439 770.5,442.9 770.5,440.8 777.3,436.9 										"/>
									</g>
                  <g>
										<polygon class="st773"
                             points="785.1,430.7 782.3,432.3 782.3,430.3 785.1,428.7 										"/>
									</g>
								</g>
                <g>
									<g>
										<polygon class="st773"
                             points="758.8,453.8 754.3,456.4 754.3,454.4 758.8,451.8 										"/>
                    <polygon class="st773"
                             points="773.7,445.2 760.8,452.7 760.8,450.6 773.7,443.2 										"/>
									</g>
								</g>
							</g>
              <g>
								<g>
									<g>
										<polygon class="st773" points="758.8,477.5 754.3,480.1 754.3,478 758.8,475.4 										"/>
                    <polygon class="st773"
                             points="773.7,468.9 760.8,476.3 760.8,474.3 773.7,466.8 										"/>
                    <polygon class="st773" points="780,465.2 775.7,467.7 775.7,465.7 780,463.2 										"/>
                    <polygon class="st773"
                             points="763.7,478.4 754.3,483.8 754.3,481.8 763.7,476.4 										"/>
                    <polygon class="st773"
                             points="768.5,475.6 765.6,477.3 765.6,475.3 768.5,473.6 										"/>
                    <polygon class="st773"
                             points="777.3,470.6 770.5,474.5 770.5,472.4 777.3,468.5 										"/>
									</g>
                  <g>
										<polygon class="st773"
                             points="785.1,462.3 782.3,463.9 782.3,461.9 785.1,460.3 										"/>
									</g>
								</g>
                <g>
									<g>
										<polygon class="st773" points="758.8,485.4 754.3,488 754.3,486 758.8,483.4 										"/>
                    <polygon class="st773"
                             points="773.7,476.8 760.8,484.3 760.8,482.2 773.7,474.8 										"/>
                    <polygon class="st773"
                             points="763.7,486.4 754.3,491.8 754.3,489.7 763.7,484.3 										"/>
                    <polygon class="st773"
                             points="768.5,483.5 765.6,485.2 765.6,483.2 768.5,481.5 										"/>
									</g>
								</g>
							</g>
              <g>
								<g class="st417">
									<path class="st782" d="M738.1,418.3c-0.2-0.1-0.4-0.1-0.6,0.1c-0.3,0.2-0.6,0.5-0.7,0.9l-11.1,28.5
										c-0.2,0.5-0.1,0.9,0.1,1.1l3.1,1.8l12.2-30.6L738.1,418.3z"/>
                  <g>
										<path class="st773" d="M740.6,420.1c0.3-0.2,0.6-0.2,0.7,0.1l11.2,15.7c0.3,0.5-0.1,1.5-0.7,1.8l-22.2,12.8
											c-0.6,0.4-1-0.2-0.7-1l11.1-28.5C740,420.6,740.3,420.3,740.6,420.1z"/>
									</g>
								</g>
                <path class="st783" d="M741.6,438.2c0.5,0,0.7,0.7,0.4,1.5c-0.2,0.5-0.6,0.9-0.9,1.2c-0.2,0.1-0.4,0.2-0.5,0.1
									c-0.5,0-0.7-0.7-0.4-1.5c0.2-0.5,0.6-0.9,0.9-1.2C741.2,438.3,741.4,438.2,741.6,438.2z M742.1,429c0-1.8-0.6-2.4-1.1-2.1
									c-0.6,0.3-1.1,1.6-1.1,3.4c0,3.7,0.5,7.2,1.1,6.8C741.6,436.8,742.1,432.7,742.1,429z"/>
							</g>
              <g>
								<g class="st417">
									<path class="st782" d="M738.1,452.9c-0.2-0.1-0.4-0.1-0.6,0.1c-0.3,0.2-0.6,0.5-0.7,0.9l-11.1,28.5
										c-0.2,0.5-0.1,0.9,0.1,1.1l3.1,1.8l12.2-30.6L738.1,452.9z"/>
                  <g>
										<path class="st773" d="M740.6,454.7c0.3-0.2,0.6-0.2,0.7,0.1l11.2,15.7c0.3,0.5-0.1,1.5-0.7,1.8l-22.2,12.8
											c-0.6,0.4-1-0.2-0.7-1l11.1-28.5C740,455.2,740.3,454.9,740.6,454.7z"/>
									</g>
								</g>
                <path class="st783" d="M741.6,472.9c0.5,0,0.7,0.7,0.4,1.5c-0.2,0.5-0.6,0.9-0.9,1.2c-0.2,0.1-0.4,0.2-0.5,0.1
									c-0.5,0-0.7-0.7-0.4-1.5c0.2-0.5,0.6-0.9,0.9-1.2C741.2,472.9,741.4,472.8,741.6,472.9z M742.1,463.7c0-1.8-0.6-2.4-1.1-2.1
									c-0.6,0.3-1.1,1.6-1.1,3.4c0,3.7,0.5,7.2,1.1,6.8C741.6,471.4,742.1,467.4,742.1,463.7z"/>
							</g>
              <g>
								<g class="st417">
									<path class="st782" d="M738.1,487.5c-0.2-0.1-0.4-0.1-0.6,0.1c-0.3,0.2-0.6,0.5-0.7,0.9L725.7,517
										c-0.2,0.5-0.1,0.9,0.1,1.1l3.1,1.8l12.2-30.6L738.1,487.5z"/>
                  <g>
										<path class="st773" d="M740.6,489.4c0.3-0.2,0.6-0.2,0.7,0.1l11.2,15.7c0.3,0.5-0.1,1.5-0.7,1.8l-22.2,12.8
											c-0.6,0.4-1-0.2-0.7-1l11.1-28.5C740,489.9,740.3,489.5,740.6,489.4z"/>
									</g>
								</g>
                <path class="st783" d="M741.6,507.5c0.5,0,0.7,0.7,0.4,1.5c-0.2,0.5-0.6,0.9-0.9,1.2c-0.2,0.1-0.4,0.2-0.5,0.1
									c-0.5,0-0.7-0.7-0.4-1.5c0.2-0.5,0.6-0.9,0.9-1.2C741.2,507.5,741.4,507.5,741.6,507.5z M742.1,498.3c0-1.8-0.6-2.4-1.1-2.1
									c-0.6,0.3-1.1,1.6-1.1,3.4c0,3.7,0.5,7.2,1.1,6.8C741.6,506,742.1,502,742.1,498.3z"/>
							</g>
						</g>
					</g>
          <path class="st784" d="M408.7,404.3c0,2.5-2,5.7-4.5,7.2c-2.5,1.5-4.5,0.6-4.5-1.9s2-5.7,4.5-7.2
						C406.7,400.9,408.7,401.8,408.7,404.3z M388,411.7c-2.5,1.5-4.5,4.7-4.5,7.2c0,2.5,2,3.4,4.5,1.9c2.5-1.5,4.5-4.7,4.5-7.2
						S390.5,410.3,388,411.7z M371.8,421.1c-2.5,1.5-4.5,4.7-4.5,7.2s2,3.4,4.5,1.9c2.5-1.5,4.5-4.7,4.5-7.2
						S374.3,419.6,371.8,421.1z"/>
          <g>
						<g class="st417">
							<path class="st772" d="M376.7,659.1c-0.8-0.5-1.9-0.3-3,0.3c-1.4,0.8-2.9,2.5-3.7,4.6l-56.8,146.7c-1,2.6-0.6,4.8,0.7,5.5
								l9.9,5.7l62.8-157.1L376.7,659.1z"/>
              <g>
								<path class="st717" d="M383.6,665.2c1.4-0.8,2.9-0.8,3.7,0.3l57.5,80.7c1.6,2.3-0.4,7.6-3.7,9.5l-114.3,66
									c-3.3,1.9-5.3-1-3.7-5.2l56.8-146.7C380.8,667.7,382.2,666,383.6,665.2z"/>
							</g>
						</g>
            <path class="st785" d="M388.9,758.3c2.6,0.2,3.5,3.6,2,7.5c-1,2.6-2.9,4.8-4.8,5.9c-0.9,0.5-1.9,0.8-2.7,0.7
							c-2.7-0.2-3.6-3.6-2-7.5c1-2.6,2.9-4.8,4.8-5.9C387,758.5,388,758.2,388.9,758.3z M391.7,711.1c0-9.4-2.9-12.5-5.7-10.9
							c-2.8,1.6-5.7,8-5.7,17.4c0.1,18.9,2.7,36.8,5.8,35C389.2,750.8,391.7,730,391.7,711.1z"/>
					</g>
				</g>
                    <g>
					<g>
						<g class="st417">

								<linearGradient id="SVGID_00000080165539702922976100000010748310827441185464_"
                                gradientUnits="userSpaceOnUse" x1="810.4519" y1="620.4432" x2="907.5024" y2="620.4432">
								<stop offset="1.071477e-03" style="stop-color:#1F715C"/>
                  <stop offset="0.2003" style="stop-color:#237761"/>
                  <stop offset="0.4783" style="stop-color:#2D8A70"/>
                  <stop offset="0.8012" style="stop-color:#3DA788"/>
                  <stop offset="1" style="stop-color:#49BD99"/>
							</linearGradient>
              <path style="fill:url(#SVGID_00000080165539702922976100000010748310827441185464_);" d="M899.5,621l-67-40.8l-22.1,37.7
								l67,40.8c8.5,4.9,20.4,0.5,26.5-9.9C910.1,638.4,908.1,625.9,899.5,621z"/>
              <path class="st737" d="M832.5,580.2c-8.6-4.9-20.4-0.5-26.5,9.9c-6.1,10.4-4.1,22.8,4.5,27.8c2,1.2,4.2,1.8,6.5,2
								c7.3,0.5,15.4-3.9,20-11.9c4.8-8.3,4.6-17.8,0-23.8C835.8,582.6,834.3,581.2,832.5,580.2z"/>
              <path class="st750" d="M837,584.2c8.4,13.7-3.9,35.4-20,35.7C834.9,622.4,848.9,598,837,584.2z"/>
						</g>
            <g>
							<path class="st787" d="M825.7,586.3l-21.5-13.1c-1.5,2.2-3,4.3-4.3,6.4c-3.4,5.3-7.5,9.8-11.5,14.3l24.2,14.7
								c5.1,2.9,12.1,0.3,15.7-5.9C831.9,596.6,830.7,589.2,825.7,586.3z"/>
						</g>
					</g>
                      <g class="st417">

							<linearGradient id="SVGID_00000167368190822859668150000005138660260904031362_"
                              gradientUnits="userSpaceOnUse" x1="833.7596" y1="478.671" x2="757.2897" y2="611.1207">
							<stop offset="0" style="stop-color:#C4BBB6"/>
                <stop offset="0.2398" style="stop-color:#D2CBC5"/>
                <stop offset="0.7154" style="stop-color:#E9E4DF"/>
                <stop offset="1" style="stop-color:#F1EEE8"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000167368190822859668150000005138660260904031362_);" d="M830.1,480.3
							c-3-4.2-6.5-7.4-10.5-9.7l-18.7-10.9c4,2.3,7.5,5.6,10.5,9.7c9,12.7,11.5,32.2,6.9,54.9c-4.6,22.7-15.7,45.9-31.3,65.3
							c-10.4,12.9-21.9,23.1-33.6,29.8c-5.9,3.4-11.7,5.9-17.6,7.5c-11.7,3.2-22.1,2.2-30.5-2.6l18.7,10.9
							c8.3,4.8,18.8,5.8,30.5,2.6c5.8-1.6,11.7-4.1,17.6-7.5c11.7-6.8,23.2-16.9,33.6-29.8c15.6-19.4,26.7-42.5,31.3-65.3
							C841.6,512.5,839.1,493,830.1,480.3z"/>
                        <path class="st789" d="M831.9,532.2c-4.6,22.7-15.8,45.9-31.3,65.3c-10.4,12.9-21.9,23.1-33.6,29.8
							c-5.9,3.4-11.7,5.9-17.6,7.5c-17.4,4.7-32,0.3-41.1-12.5c-18.7-26.3-7.8-80.2,24.4-120.2c10.6-13.2,22.2-23.2,33.6-29.8
							c23.3-13.5,46.1-12.7,58.7,5C834,490,836.5,509.6,831.9,532.2z"/>

                        <linearGradient id="SVGID_00000156581010094061788590000001852340753716620962_"
                                        gradientUnits="userSpaceOnUse" x1="787.8976" y1="444.511" x2="686.076"
                                        y2="620.8713">
							<stop offset="0" style="stop-color:#F7F4F3"/>
                          <stop offset="0.1286" style="stop-color:#F2EEF0"/>
                          <stop offset="0.2988" style="stop-color:#E3DDE8"/>
                          <stop offset="0.4921" style="stop-color:#CAC2DA"/>
                          <stop offset="0.7026" style="stop-color:#A79CC7"/>
                          <stop offset="0.9247" style="stop-color:#7B6BAF"/>
                          <stop offset="1" style="stop-color:#6B59A6"/>
						</linearGradient>
                        <path style="fill:url(#SVGID_00000156581010094061788590000001852340753716620962_);" d="M804.2,453.9
							c-13.8-8-32.5-5.9-51.5,5.1c-12.2,7.1-24.6,17.8-35.9,31.9c-34.4,42.8-46.1,100.4-26.1,128.5c3.2,4.5,7,8,11.3,10.5l18.7,10.9
							c-4.3-2.5-8.2-6-11.3-10.5c-20-28.1-8.3-85.8,26.1-128.5c11.3-14.1,23.7-24.8,35.9-31.9c19.1-11,37.8-13.1,51.5-5.1
							L804.2,453.9z"/>
                        <path class="st787" d="M834.1,475.2c-13.4-18.9-37.8-19.7-62.8-5.3c-12.2,7.1-24.6,17.8-35.9,31.9
							c-12.6,15.7-22.2,33.5-28.3,51c-10.4,30.2-10.5,59.8,2.2,77.5c9.7,13.7,25.3,18.4,43.9,13.4c6.2-1.7,12.5-4.4,18.8-8
							c12.5-7.2,24.8-18.1,35.9-31.9c16.7-20.7,28.6-45.5,33.5-69.8C846.4,509.7,843.8,488.8,834.1,475.2z M837,535.2
							c-4.6,22.7-15.8,45.9-31.3,65.3c-10.4,12.9-21.9,23.1-33.6,29.8c-5.9,3.4-11.7,5.9-17.6,7.5c-17.4,4.7-32,0.3-41.1-12.5
							c-18.7-26.3-7.8-80.2,24.4-120.2c10.6-13.2,22.2-23.2,33.6-29.8c23.3-13.5,46.1-12.7,58.7,5C839.1,493,841.6,512.5,837,535.2z
							"/>
                        <path class="st772" d="M815.3,461.5c-1.1-0.4-2.7-0.8-4.8-1.2c-4.2-0.8-10.4-1.2-17.6,0.3c-7.2,1.4-15.3,4.5-23.2,9.1
							c-7.9,4.6-15.6,10.7-22.6,17.4c-6.9,6.8-13.1,14.4-18.4,21.8c-5.3,7.4-9.4,14.9-12.6,21.4c-3.2,6.5-5.4,12.2-6.8,16.2
							c-1.4,4-2.1,6.3-2.1,6.3s0.8-2.3,2.5-6.2c1.6-3.9,4.2-9.3,7.7-15.7c3.4-6.4,7.9-13.5,13.2-20.8c5.3-7.3,11.5-14.7,18.4-21.3
							c13.5-13.6,30.4-23.8,44.4-27c7-1.7,13.1-1.8,17.2-1.2c2.1,0.2,3.7,0.6,4.8,0.9c1.1,0.3,1.7,0.5,1.7,0.5
							S816.4,461.9,815.3,461.5z"/>
					</g>
				</g>
			</g>
		</g>
	</g>
</g>
</svg>
        </div>
      </template>
      <span>BI & Analytics</span>
    </v-tooltip>
  </div>
</template>

<script>
/**
 * @component DashboardButton
 * Home button component that redirects to Dashboard page
 */
export default {
  name: 'BIAnalyticsButton',
  props: {
    isMobileOrTablet: {
      type: Boolean,
      default: false,
    }
  },
  methods: {
    goToBIAnalyticsPage() {
      // this.$router.push('/dashboard');
      /**
       * Handle the Client string presence and modify the BI & Analytics link
       * accordingly
       */
      const clientIdentifier = window?.location?.hostname.split('.').length > 2 ? window?.location?.hostname.split('.')[0] : null;
      let refinedURL = '';
      if (!!clientIdentifier && (clientIdentifier.length > 0)) {
        let refinedURLBuffer = window.location.hostname.split('.');
        refinedURLBuffer[0] = refinedURLBuffer[0].replace(clientIdentifier, `analytics-${clientIdentifier}`);
        refinedURL = `https://${refinedURLBuffer.join('.')}/`;
      } else {
        refinedURL = `https://analytics.${window.location.hostname}/`;
      }
      window.open(refinedURL, '_blank');
    },
  }
}

</script>

<style lang="scss" scoped>
.main-light {
  .home-button {
    background-color: rgba(0, 0, 0, 0.15);
    border: 4px solid #5c9485;
    box-shadow: 0 0 2px rgba(0, 0, 0, 0.7);

    &:hover {
      background-color: rgb(255, 255, 255);
      border: 4px solid #4ABD96 !important;
      box-shadow: 5px 5px 14px rgba(0, 0, 0, 0.7);
      cursor: pointer;
      z-index: 99999;
      transform: scale(1.1);
    }
  }
}
</style>

<style scoped>
.st0 {
  clip-path: url(#SVGID_00000143599067970867445640000008819419232889109647_);
}

.st1 {
  clip-path: url(#SVGID_00000153696931107964800160000004873656916210285202_);
  enable-background: new;
}

.st2 {
  clip-path: url(#SVGID_00000059270314109587189040000003510030503303602328_);
}

.st3 {
  clip-path: url(#SVGID_00000118394827057845857900000001643024060967620497_);
}

.st4 {
  opacity: 0;
  clip-path: url(#SVGID_00000168833284276099217060000003101920010013169824_);
}

.st5 {
  opacity: 0;
}

.st6 {
  clip-path: url(#SVGID_00000078764949474960965710000018217506957389515448_);
}

.st7 {
  clip-path: url(#SVGID_00000128481359132638213590000004170230126503943051_);
}

.st8 {
  clip-path: url(#SVGID_00000050645511423151417410000014928854642891190192_);
  fill: #3FB994;
}

.st9 {
  clip-path: url(#SVGID_00000029742106236214326960000012877672214727977879_);
}

.st10 {
  clip-path: url(#SVGID_00000011750867697777326470000008355917696944586116_);
  enable-background: new;
}

.st11 {
  clip-path: url(#SVGID_00000165924081052624766270000015980084058439760829_);
}

.st12 {
  clip-path: url(#SVGID_00000002363627184014276600000003196651445650038970_);
}

.st13 {
  clip-path: url(#SVGID_00000116956839401892802000000004779988777641685647_);
  fill: #3FB994;
}

.st14 {
  clip-path: url(#SVGID_00000110429534257045925860000003307104518841767853_);
}

.st15 {
  clip-path: url(#SVGID_00000078732326814332134910000014487671752573242034_);
}

.st16 {
  clip-path: url(#SVGID_00000036940366625702510950000010874044157071997877_);
  fill: #3FB994;
}

.st17 {
  clip-path: url(#SVGID_00000026129860987256284820000003492271030907105973_);
}

.st18 {
  clip-path: url(#SVGID_00000083776539302388498950000013948113987096525998_);
}

.st19 {
  clip-path: url(#SVGID_00000143596070346825481540000008795753404487061391_);
  fill: #3FB994;
}

.st20 {
  clip-path: url(#SVGID_00000051371746825066941340000012599937478635859128_);
}

.st21 {
  clip-path: url(#SVGID_00000026868431918169079950000006982982198161841081_);
}

.st22 {
  clip-path: url(#SVGID_00000164497312332516300320000010326057321212860822_);
  fill: #3FB994;
}

.st23 {
  clip-path: url(#SVGID_00000106861844436338583910000005916408011846537125_);
}

.st24 {
  clip-path: url(#SVGID_00000123430637174078005410000006685591455936943014_);
}

.st25 {
  clip-path: url(#SVGID_00000076595651752382758630000012259121222817272739_);
  fill: #3FB994;
}

.st26 {
  clip-path: url(#SVGID_00000170256152230081105990000006411535790728464263_);
}

.st27 {
  clip-path: url(#SVGID_00000101105509832250467180000011938294557171894930_);
}

.st28 {
  clip-path: url(#SVGID_00000181055351627825797930000009259937174011604371_);
  fill: #3FB994;
}

.st29 {
  clip-path: url(#SVGID_00000005949079456219968640000002810605625117229187_);
}

.st30 {
  clip-path: url(#SVGID_00000096043310643029569700000001262067456103148205_);
}

.st31 {
  clip-path: url(#SVGID_00000047027433931897514990000002322598860476596650_);
  fill: #3FB994;
}

.st32 {
  clip-path: url(#SVGID_00000005980639827889544760000004882112318682792107_);
}

.st33 {
  clip-path: url(#SVGID_00000104670699881897500460000009126030759993437093_);
}

.st34 {
  clip-path: url(#SVGID_00000042738362932740139060000009527080740435963533_);
  fill: #3FB994;
}

.st35 {
  clip-path: url(#SVGID_00000048462501902105521510000008193186267654638266_);
}

.st36 {
  clip-path: url(#SVGID_00000029764655181840368370000016087922695915189135_);
}

.st37 {
  clip-path: url(#SVGID_00000044897631860473532920000014332648297181836965_);
  fill: #3FB994;
}

.st38 {
  clip-path: url(#SVGID_00000083087158440667780240000016224515409097455018_);
}

.st39 {
  clip-path: url(#SVGID_00000050665047589794103090000012364569154312085168_);
}

.st40 {
  clip-path: url(#SVGID_00000179610138324394399690000006827760720513329591_);
  fill: #3FB994;
}

.st41 {
  clip-path: url(#SVGID_00000067958203188844768000000002817461690409773729_);
}

.st42 {
  clip-path: url(#SVGID_00000010287983571867739590000006082669205830051469_);
}

.st43 {
  clip-path: url(#SVGID_00000147189835097442098970000004389956167606851222_);
  fill: #3FB994;
}

.st44 {
  clip-path: url(#SVGID_00000119834622191653092810000016087298538867628190_);
}

.st45 {
  clip-path: url(#SVGID_00000182525456000660335060000003305643698544142232_);
}

.st46 {
  clip-path: url(#SVGID_00000109017591600951962370000002009524897004275122_);
  fill: #3FB994;
}

.st47 {
  clip-path: url(#SVGID_00000049926701853302925790000010159086393103164325_);
}

.st48 {
  clip-path: url(#SVGID_00000095313907764519598110000000752662561723791546_);
}

.st49 {
  clip-path: url(#SVGID_00000094597501264127081420000005106171113926051736_);
  fill: #3FB994;
}

.st50 {
  clip-path: url(#SVGID_00000129909971377925548410000017507407662309652365_);
}

.st51 {
  clip-path: url(#SVGID_00000016045256322100710160000001511632814947279253_);
  enable-background: new;
}

.st52 {
  clip-path: url(#SVGID_00000091696733135236264370000002499606043262049940_);
}

.st53 {
  clip-path: url(#SVGID_00000029754263943855442240000013836174620983615626_);
}

.st54 {
  clip-path: url(#SVGID_00000044865748605355853410000016092275889258593956_);
  fill: #306175;
}

.st55 {
  clip-path: url(#SVGID_00000181810130784957422450000016590368954909136032_);
}

.st56 {
  clip-path: url(#SVGID_00000142169134838685654920000003350667193727415723_);
}

.st57 {
  clip-path: url(#SVGID_00000047050665703306736190000006702976877113731975_);
  fill: #32657A;
}

.st58 {
  clip-path: url(#SVGID_00000151544253156183754000000017933080956160821430_);
}

.st59 {
  clip-path: url(#SVGID_00000070811728545590234960000003647414106712912006_);
}

.st60 {
  clip-path: url(#SVGID_00000121244463078631205470000012310819054063350671_);
  fill: #34697F;
}

.st61 {
  clip-path: url(#SVGID_00000103969084414736444470000007089688147587427728_);
}

.st62 {
  clip-path: url(#SVGID_00000065036207338132201840000007767539959619839377_);
}

.st63 {
  clip-path: url(#SVGID_00000122716815013664104740000009483986068040106154_);
  fill: #366C82;
}

.st64 {
  clip-path: url(#SVGID_00000054985427903272732650000010030510817656249216_);
}

.st65 {
  clip-path: url(#SVGID_00000045616548096468341440000004233461018082951560_);
  enable-background: new;
}

.st66 {
  clip-path: url(#SVGID_00000026847709190812114830000014270659353222323866_);
}

.st67 {
  clip-path: url(#SVGID_00000104678072379745026990000008152609911361311159_);
}

.st68 {
  opacity: 0;
  clip-path: url(#SVGID_00000148635575412981898020000015870598538156253601_);
}

.st69 {
  clip-path: url(#SVGID_00000028312592766057079130000011642461098736617379_);
}

.st70 {
  clip-path: url(#SVGID_00000021079788925195161440000005830269953461040017_);
}

.st71 {
  clip-path: url(#SVGID_00000070796952696029758420000008970760309416424837_);
  fill: #3FB994;
}

.st72 {
  clip-path: url(#SVGID_00000054236597816051410450000004806093844403413641_);
}

.st73 {
  clip-path: url(#SVGID_00000080174500701840308800000018333182473303992732_);
  enable-background: new;
}

.st74 {
  clip-path: url(#SVGID_00000026869150288841135360000008899731048256177039_);
}

.st75 {
  clip-path: url(#SVGID_00000066504377153119045530000007763340003170789505_);
}

.st76 {
  clip-path: url(#SVGID_00000101798468443754623120000016213921492624277395_);
  fill: #3FB994;
}

.st77 {
  clip-path: url(#SVGID_00000176022823730553510760000017199933587230619292_);
}

.st78 {
  clip-path: url(#SVGID_00000147908373947079372410000009275879555453562016_);
}

.st79 {
  clip-path: url(#SVGID_00000085968642447715916180000008822033578502959038_);
  fill: #3FB994;
}

.st80 {
  clip-path: url(#SVGID_00000048500672704449333700000018356381752968058269_);
}

.st81 {
  clip-path: url(#SVGID_00000116943161401304325340000004595752786108161169_);
}

.st82 {
  clip-path: url(#SVGID_00000048466038552587554770000004055027618396317086_);
  fill: #3FB994;
}

.st83 {
  clip-path: url(#SVGID_00000036966825743408564790000011419964552500097418_);
}

.st84 {
  clip-path: url(#SVGID_00000078740784376949707030000001419739039023601813_);
}

.st85 {
  clip-path: url(#SVGID_00000027563644432946261530000002492686720904370103_);
  fill: #3FB994;
}

.st86 {
  clip-path: url(#SVGID_00000140732871105495290690000009393787699460258473_);
}

.st87 {
  clip-path: url(#SVGID_00000158024737878567886690000009166966687092637622_);
}

.st88 {
  clip-path: url(#SVGID_00000121970444744025871440000001489009491084926863_);
  fill: #3FB994;
}

.st89 {
  clip-path: url(#SVGID_00000101080213653454625250000003226033112013881776_);
}

.st90 {
  clip-path: url(#SVGID_00000160176180057311605840000012945303873219161498_);
}

.st91 {
  clip-path: url(#SVGID_00000039097391927195917420000012517220410069719965_);
  fill: #3FB994;
}

.st92 {
  clip-path: url(#SVGID_00000025419122733862355660000011488042515568874395_);
}

.st93 {
  clip-path: url(#SVGID_00000147932235256440661480000012411429530534347143_);
}

.st94 {
  clip-path: url(#SVGID_00000180331477983775136530000011239724217457765564_);
  fill: #3FB994;
}

.st95 {
  clip-path: url(#SVGID_00000156579904649695366130000015751557407732230303_);
}

.st96 {
  clip-path: url(#SVGID_00000140736611425871113400000013302838568273517463_);
}

.st97 {
  clip-path: url(#SVGID_00000013162423792729169850000014358706414778828731_);
  fill: #3FB994;
}

.st98 {
  clip-path: url(#SVGID_00000064350895751584278160000001298024962590005128_);
}

.st99 {
  clip-path: url(#SVGID_00000023993708237009077200000003593283052808171649_);
}

.st100 {
  clip-path: url(#SVGID_00000057124082227401475090000006176639675056959656_);
  fill: #3FB994;
}

.st101 {
  clip-path: url(#SVGID_00000096775708133978737090000014507163049126852773_);
}

.st102 {
  clip-path: url(#SVGID_00000153695793704604424730000009595211795357153967_);
}

.st103 {
  clip-path: url(#SVGID_00000163776820886970234530000010046931481053679267_);
  fill: #3FB994;
}

.st104 {
  clip-path: url(#SVGID_00000043415746074490725780000001177187431879360954_);
}

.st105 {
  clip-path: url(#SVGID_00000050658353463544738160000007107663989368614313_);
}

.st106 {
  clip-path: url(#SVGID_00000146469675049117349910000006905755434377153447_);
  fill: #3FB994;
}

.st107 {
  clip-path: url(#SVGID_00000008851934887086016740000014193403479264475265_);
}

.st108 {
  clip-path: url(#SVGID_00000103969311312085076030000010944945972649921427_);
}

.st109 {
  clip-path: url(#SVGID_00000054237364477877269320000013801350502743610496_);
  fill: #3FB994;
}

.st110 {
  clip-path: url(#SVGID_00000160871082387656233660000013896351455655477691_);
}

.st111 {
  clip-path: url(#SVGID_00000078735102399323138810000000436973372498272684_);
}

.st112 {
  clip-path: url(#SVGID_00000129179884349544468290000012426306310897056162_);
  fill: #3FB994;
}

.st113 {
  clip-path: url(#SVGID_00000002364756645664952810000005295974082718409907_);
}

.st114 {
  clip-path: url(#SVGID_00000116193577394154693870000006888987026475723163_);
}

.st115 {
  clip-path: url(#SVGID_00000139998827582187894090000003020853885784071061_);
  fill: #3FB994;
}

.st116 {
  clip-path: url(#SVGID_00000040572460104100946240000009457920794541203127_);
}

.st117 {
  clip-path: url(#SVGID_00000015313172735817850640000009910985973323429771_);
}

.st118 {
  clip-path: url(#SVGID_00000111869433576913826580000003393175239869194687_);
  fill: #3FB994;
}

.st119 {
  clip-path: url(#SVGID_00000163788686446367455470000007501204986784859784_);
}

.st120 {
  clip-path: url(#SVGID_00000091725349526535560270000007831136072494943149_);
}

.st121 {
  clip-path: url(#SVGID_00000053542985317654191110000013969114432687051199_);
  fill: #3FB994;
}

.st122 {
  clip-path: url(#SVGID_00000067920227219481282640000000964919369875969196_);
}

.st123 {
  clip-path: url(#SVGID_00000036219691419597346910000006137159418708790197_);
}

.st124 {
  clip-path: url(#SVGID_00000121978239188185252460000010175049998032763046_);
  fill: #3FB994;
}

.st125 {
  clip-path: url(#SVGID_00000034090219891778825180000002668824029827769519_);
}

.st126 {
  clip-path: url(#SVGID_00000147926684647099873680000004248335592455213212_);
}

.st127 {
  clip-path: url(#SVGID_00000142169959599088042020000004536480409225230779_);
  fill: #3FB994;
}

.st128 {
  clip-path: url(#SVGID_00000101788296798174892170000015216106167172676495_);
}

.st129 {
  clip-path: url(#SVGID_00000158741809871621036320000002682587199479574201_);
  fill: #154C3D;
}

.st130 {
  clip-path: url(#SVGID_00000145030264382096184730000011693975530406289571_);
}

.st131 {
  clip-path: url(#SVGID_00000105410968755704373250000014177241327603935633_);
  fill: #226A57;
}

.st132 {
  clip-path: url(#SVGID_00000129180997988059024720000010947527492056252607_);
}

.st133 {
  clip-path: url(#SVGID_00000094612389719904287030000008718118075817037696_);
  fill: #226A57;
}

.st134 {
  clip-path: url(#SVGID_00000075146967027075912930000012578993408933169054_);
}

.st135 {
  clip-path: url(#SVGID_00000088823161384523356500000000903400803623005857_);
  fill: #3FB994;
}

.st136 {
  clip-path: url(#SVGID_00000013892280154607051110000000269019427395819190_);
}

.st137 {
  clip-path: url(#SVGID_00000072962815111203714590000017731316844885874054_);
  fill: #3FB994;
}

.st138 {
  clip-path: url(#SVGID_00000127738798460919081750000001427794081210133678_);
}

.st139 {
  clip-path: url(#SVGID_00000034768604363239953640000009126096081034756017_);
  fill: #25292A;
}

.st140 {
  clip-path: url(#SVGID_00000154399214094110094750000017388260131027048097_);
}

.st141 {
  clip-path: url(#SVGID_00000111188849156472449830000003757650249208970917_);
  fill: #3FB994;
}

.st142 {
  clip-path: url(#SVGID_00000071550036502773481450000013094948950947207862_);
}

.st143 {
  clip-path: url(#SVGID_00000161605878244549322200000013396360900933127337_);
  fill: #42B994;
}

.st144 {
  clip-path: url(#SVGID_00000008113822448933598240000010966029963787235490_);
}

.st145 {
  clip-path: url(#SVGID_00000030459765549361821230000006182804336044781982_);
  fill: #25292A;
}

.st146 {
  clip-path: url(#SVGID_00000008865251878118309720000006651370650889315517_);
}

.st147 {
  clip-path: url(#SVGID_00000127745697427109841560000005570075942527635113_);
  fill: #42B994;
}

.st148 {
  clip-path: url(#SVGID_00000066499410315500494170000015014576911862239110_);
}

.st149 {
  clip-path: url(#SVGID_00000089535527909206494830000000139715951032743612_);
  fill: #25292A;
}

.st150 {
  clip-path: url(#SVGID_00000019677144736421418390000009278217881056856255_);
}

.st151 {
  clip-path: url(#SVGID_00000145053312763804436120000006895314840101175715_);
  fill: #42B994;
}

.st152 {
  clip-path: url(#SVGID_00000016754806137208167810000003525231125001291657_);
}

.st153 {
  clip-path: url(#SVGID_00000015315482374101614860000000351545375525626537_);
  fill: #25292A;
}

.st154 {
  clip-path: url(#SVGID_00000183931939890823929230000016813686743916435891_);
}

.st155 {
  clip-path: url(#SVGID_00000113333246370338070960000016921385210798138529_);
  enable-background: new;
}

.st156 {
  clip-path: url(#SVGID_00000078028399430798252040000012491427987058047404_);
}

.st157 {
  clip-path: url(#SVGID_00000047029165718267816550000000253042850735013285_);
}

.st158 {
  clip-path: url(#SVGID_00000143613068601746501720000016100759649601082796_);
  fill: #25292A;
}

.st159 {
  clip-path: url(#SVGID_00000013186695698752489870000012094351778883366077_);
}

.st160 {
  clip-path: url(#SVGID_00000088846507660303727030000007555555307605537423_);
}

.st161 {
  clip-path: url(#SVGID_00000052803368101573401700000017305201579279369375_);
  fill: #25292A;
}

.st162 {
  clip-path: url(#SVGID_00000129201149195030407790000008069916487091064744_);
}

.st163 {
  clip-path: url(#SVGID_00000070830034221358115550000001400977507362867610_);
  enable-background: new;
}

.st164 {
  clip-path: url(#SVGID_00000132052466645805862210000001513815250751947168_);
}

.st165 {
  clip-path: url(#SVGID_00000100344589207802510570000006128279733621411205_);
}

.st166 {
  clip-path: url(#SVGID_00000121268626965866255760000012601936356387757992_);
  fill: #3FB994;
}

.st167 {
  clip-path: url(#SVGID_00000152246000086325843470000013993272946466525602_);
}

.st168 {
  clip-path: url(#SVGID_00000152978958809430924820000005953079520098632611_);
}

.st169 {
  clip-path: url(#SVGID_00000041255666733543377160000009926651595580255403_);
  fill: #001820;
}

.st170 {
  clip-path: url(#SVGID_00000179619203851020138830000010175027632393623434_);
}

.st171 {
  clip-path: url(#SVGID_00000003789362419864590260000003832853179629774744_);
  fill: #25292A;
}

.st172 {
  clip-path: url(#SVGID_00000149353959871325884310000015342508393281998747_);
}

.st173 {
  clip-path: url(#SVGID_00000061434823872620433950000014825141310668274608_);
  fill: #25292A;
}

.st174 {
  clip-path: url(#SVGID_00000022520932371680861750000014960682131700010919_);
}

.st175 {
  clip-path: url(#SVGID_00000083778440846608555350000014712814543999802011_);
  fill: #A4A6A5;
}

.st176 {
  clip-path: url(#SVGID_00000011027485329935952340000008912199354045574046_);
}

.st177 {
  clip-path: url(#SVGID_00000022539246161851535650000011183393522606563240_);
  fill: #9CB3C6;
}

.st178 {
  clip-path: url(#SVGID_00000012470632298044569590000002233127547855268799_);
}

.st179 {
  clip-path: url(#SVGID_00000148627741501923268630000016553145892700244118_);
  fill: #9CB3C6;
}

.st180 {
  clip-path: url(#SVGID_00000109734372392185507920000010435827474410986113_);
}

.st181 {
  clip-path: url(#SVGID_00000096038750689796346220000014599208759117202588_);
  fill: #25292A;
}

.st182 {
  clip-path: url(#SVGID_00000071518637461801674240000015222799723984258991_);
}

.st183 {
  clip-path: url(#SVGID_00000090258863534677110350000017646542289004220346_);
  fill: #E0E1DB;
}

.st184 {
  clip-path: url(#SVGID_00000137126465949567742360000016872100072702465710_);
}

.st185 {
  clip-path: url(#SVGID_00000132781561575723193610000010292910795679714229_);
  fill: #25292A;
}

.st186 {
  clip-path: url(#SVGID_00000039841968624254314000000018436345791109064589_);
}

.st187 {
  clip-path: url(#SVGID_00000168081850725898481990000006594215412384235445_);
  fill: #25292A;
}

.st188 {
  clip-path: url(#SVGID_00000133502760632136746150000011746539845997369773_);
}

.st189 {
  clip-path: url(#SVGID_00000158737305622531104300000015544770908348291232_);
  fill: #25292A;
}

.st190 {
  clip-path: url(#SVGID_00000083080461104354331320000006814430991025326510_);
}

.st191 {
  clip-path: url(#SVGID_00000134208839708733693350000003570141371576839085_);
  fill: #A4A6A5;
}

.st192 {
  clip-path: url(#SVGID_00000068679307657372517150000009236871546778943108_);
}

.st193 {
  clip-path: url(#SVGID_00000168079058419387933280000016540102229519107982_);
  enable-background: new;
}

.st194 {
  clip-path: url(#SVGID_00000131341821884613980810000007586860014533395864_);
}

.st195 {
  clip-path: url(#SVGID_00000046303531423656229570000012499037165702038924_);
}

.st196 {
  opacity: 0;
  clip-path: url(#SVGID_00000121992213032749796750000001116719639211814802_);
}

.st197 {
  clip-path: url(#SVGID_00000140700839812537752300000001583100168816390573_);
}

.st198 {
  clip-path: url(#SVGID_00000007396897599031355060000000410029131097939096_);
}

.st199 {
  clip-path: url(#SVGID_00000016073764913188107710000000380284988694795193_);
  enable-background: new;
}

.st200 {
  clip-path: url(#SVGID_00000109739446079376970260000001207388680354439335_);
}

.st201 {
  clip-path: url(#SVGID_00000097494578325524449230000000654180366100102548_);
}

.st202 {
  opacity: 0;
  clip-path: url(#SVGID_00000054981709855131588710000007648952740004926095_);
}

.st203 {
  clip-path: url(#SVGID_00000112602105213640529880000007051628396781762180_);
}

.st204 {
  clip-path: url(#SVGID_00000160877195078410601670000009790693254424349365_);
}

.st205 {
  clip-path: url(#SVGID_00000070080847506534338730000008728644260840345231_);
  enable-background: new;
}

.st206 {
  clip-path: url(#SVGID_00000161609046749408553160000010497640765629633154_);
}

.st207 {
  clip-path: url(#SVGID_00000071545664902453302230000014635970962747557565_);
}

.st208 {
  opacity: 0;
  clip-path: url(#SVGID_00000044160485501893722010000008167452734085065389_);
}

.st209 {
  clip-path: url(#SVGID_00000000186961166436339650000000258696956597905047_);
}

.st210 {
  clip-path: url(#SVGID_00000076570095511826425450000002432671490536715392_);
}

.st211 {
  clip-path: url(#SVGID_00000004512654946270202760000014361325830669011896_);
  fill: #4EBD99;
}

.st212 {
  clip-path: url(#SVGID_00000003102961046241243790000012519335657386858387_);
}

.st213 {
  clip-path: url(#SVGID_00000083784326769818567960000004628721565202477232_);
  fill: #42B994;
}

.st214 {
  clip-path: url(#SVGID_00000060012815472357237410000005690414434724860340_);
}

.st215 {
  clip-path: url(#SVGID_00000043455134436978800950000003535228356312507827_);
  fill: #226A57;
}

.st216 {
  clip-path: url(#SVGID_00000139991868910666203410000003750078229725293698_);
}

.st217 {
  clip-path: url(#SVGID_00000008860272298665599920000002399565300677259159_);
  fill: #165748;
}

.st218 {
  clip-path: url(#SVGID_00000104665479254020910590000016875859546270308795_);
}

.st219 {
  clip-path: url(#SVGID_00000124140117959294135780000016713162741854034108_);
  fill: #42B994;
}

.st220 {
  clip-path: url(#SVGID_00000016060408418055722530000011146508390588736673_);
}

.st221 {
  clip-path: url(#SVGID_00000062169200728697127490000011015958138969493920_);
  fill: #226A57;
}

.st222 {
  clip-path: url(#SVGID_00000027583930449005331980000012672554075160269980_);
}

.st223 {
  clip-path: url(#SVGID_00000005950738745646158020000014517419369432038831_);
  fill: #165748;
}

.st224 {
  clip-path: url(#SVGID_00000035521896412437618910000008412020916715705996_);
}

.st225 {
  clip-path: url(#SVGID_00000058566008102399633170000002343650742562889906_);
  fill: #42B994;
}

.st226 {
  clip-path: url(#SVGID_00000030466214298900154780000006196838616830093502_);
}

.st227 {
  clip-path: url(#SVGID_00000163766063539582380050000004495512547702928574_);
  fill: #226A57;
}

.st228 {
  clip-path: url(#SVGID_00000136386680514074150200000015251650112194134709_);
}

.st229 {
  clip-path: url(#SVGID_00000036937762488149134120000014676258155905069750_);
  fill: #165748;
}

.st230 {
  clip-path: url(#SVGID_00000110470163104701622030000003896218210710598846_);
}

.st231 {
  clip-path: url(#SVGID_00000093874602908336846070000009192685800032596400_);
  fill: #42B994;
}

.st232 {
  clip-path: url(#SVGID_00000149362448694647305540000009384464960919596464_);
}

.st233 {
  clip-path: url(#SVGID_00000148662981126180297270000005065346496780051331_);
  fill: #226A57;
}

.st234 {
  clip-path: url(#SVGID_00000059268453773984220470000005997262823720924094_);
}

.st235 {
  clip-path: url(#SVGID_00000095307012557721054390000002926445547917868976_);
  fill: #165748;
}

.st236 {
  clip-path: url(#SVGID_00000031209469259568254900000006376050991879797662_);
}

.st237 {
  clip-path: url(#SVGID_00000022549933808626730260000001749983740784320405_);
  fill: #42B994;
}

.st238 {
  clip-path: url(#SVGID_00000086657933311250937230000011407522452120899261_);
}

.st239 {
  clip-path: url(#SVGID_00000151507666973100629760000013789670724021116090_);
  fill: #226A57;
}

.st240 {
  clip-path: url(#SVGID_00000027596573078677274340000003817926482225699218_);
}

.st241 {
  clip-path: url(#SVGID_00000152949448608757108130000011601524308977772208_);
  fill: #165748;
}

.st242 {
  clip-path: url(#SVGID_00000063590884222018193000000000129860187490578567_);
}

.st243 {
  clip-path: url(#SVGID_00000033368197178601916600000009079430906937906064_);
  fill: #226A57;
}

.st244 {
  clip-path: url(#SVGID_00000167361302565554211810000000680768371605986738_);
}

.st245 {
  clip-path: url(#SVGID_00000059298740629630198030000001961759701439161252_);
  fill: #FFFFFF;
}

.st246 {
  clip-path: url(#SVGID_00000082351105411704748510000005603950480857079228_);
}

.st247 {
  clip-path: url(#SVGID_00000138553124089866474160000016544085721186279323_);
  fill: #226A57;
}

.st248 {
  clip-path: url(#SVGID_00000025412691832636626890000001293821295754304131_);
}

.st249 {
  clip-path: url(#SVGID_00000021086363506596226800000012216887021931432625_);
  fill: #42B994;
}

.st250 {
  clip-path: url(#SVGID_00000179630263863637639840000016451181085063903656_);
}

.st251 {
  clip-path: url(#SVGID_00000150813292547652114910000011917312485524072348_);
  fill: #226A57;
}

.st252 {
  clip-path: url(#SVGID_00000078730233354311498170000002091329164901862058_);
}

.st253 {
  clip-path: url(#SVGID_00000163759648653511409660000007155146429695389103_);
  fill: #42B994;
}

.st254 {
  clip-path: url(#SVGID_00000055701370872987244340000004065956414734374284_);
}

.st255 {
  clip-path: url(#SVGID_00000065763968613070354210000003556958474884343186_);
  fill: #226A57;
}

.st256 {
  clip-path: url(#SVGID_00000027579331992849963530000015932205367079088264_);
}

.st257 {
  clip-path: url(#SVGID_00000003812697983935756030000000626278038499680132_);
  fill: #42B994;
}

.st258 {
  clip-path: url(#SVGID_00000158728685035043267420000010702262916994341016_);
}

.st259 {
  clip-path: url(#SVGID_00000085951839562918487870000016121022296982854530_);
  fill: #EBEAE6;
}

.st260 {
  clip-path: url(#SVGID_00000091708747338929116230000007394369019842551689_);
}

.st261 {
  clip-path: url(#SVGID_00000127735102083965498520000009945173114860510142_);
  fill: #DCDDD7;
}

.st262 {
  clip-path: url(#SVGID_00000115516800273223128290000011555639047421782943_);
}

.st263 {
  clip-path: url(#SVGID_00000158028729410043847210000001995305358712484741_);
  fill: #868B89;
}

.st264 {
  clip-path: url(#SVGID_00000134971603541687617260000012950483336075125426_);
}

.st265 {
  clip-path: url(#SVGID_00000096764419414182315490000006925204824611844507_);
  fill: #95CCB9;
}

.st266 {
  clip-path: url(#SVGID_00000109748515174016151260000006845498782320290987_);
}

.st267 {
  clip-path: url(#SVGID_00000181057464396927990100000017664529672373169854_);
  fill: #82A79C;
}

.st268 {
  clip-path: url(#SVGID_00000005980355060413912180000003301640313668643200_);
}

.st269 {
  clip-path: url(#SVGID_00000044899605399557747510000003721541865647224750_);
  fill: #7FA096;
}

.st270 {
  clip-path: url(#SVGID_00000088835413966763488300000002778434884821557415_);
}

.st271 {
  clip-path: url(#SVGID_00000067193784099118004050000007364056044147285934_);
  fill: #95CCB9;
}

.st272 {
  clip-path: url(#SVGID_00000000910522723904691600000012367207831994619542_);
}

.st273 {
  clip-path: url(#SVGID_00000126321288854929734120000005854288583059804061_);
  fill: #82A79C;
}

.st274 {
  clip-path: url(#SVGID_00000081607896132222040930000005839905190027987624_);
}

.st275 {
  clip-path: url(#SVGID_00000045589600531892473060000004407672648168742830_);
  fill: #7FA096;
}

.st276 {
  clip-path: url(#SVGID_00000114051948769496865400000014607920294494317185_);
}

.st277 {
  clip-path: url(#SVGID_00000124845584135193548640000011008111092765266860_);
  fill: #95CCB9;
}

.st278 {
  clip-path: url(#SVGID_00000007399110316499671600000008978416309952028546_);
}

.st279 {
  clip-path: url(#SVGID_00000080891829344998472530000018079693904748585644_);
  fill: #82A79C;
}

.st280 {
  clip-path: url(#SVGID_00000134208700452800235630000005943018043886246051_);
}

.st281 {
  clip-path: url(#SVGID_00000084513799104169672030000003659759836600722358_);
  fill: #95CCB9;
}

.st282 {
  clip-path: url(#SVGID_00000062896189873675069590000005766329737667461010_);
}

.st283 {
  clip-path: url(#SVGID_00000172403104251782454660000015216751080938411409_);
  fill: #82A79C;
}

.st284 {
  clip-path: url(#SVGID_00000167364944329531629320000006610940017210102421_);
}

.st285 {
  clip-path: url(#SVGID_00000048476474282797356040000002770522987951756955_);
  fill: #7FA096;
}

.st286 {
  clip-path: url(#SVGID_00000146459630763139505600000018100022196636315571_);
}

.st287 {
  clip-path: url(#SVGID_00000038403688452174627720000001302956009396906145_);
  fill: #95CCB9;
}

.st288 {
  clip-path: url(#SVGID_00000173879624176148930100000002225289892662314162_);
}

.st289 {
  clip-path: url(#SVGID_00000056410970812649759820000005302315284416558223_);
  fill: #7FA096;
}

.st290 {
  clip-path: url(#SVGID_00000138569127406613443070000000500769728861263769_);
}

.st291 {
  clip-path: url(#SVGID_00000071541327466721657370000010937054889092698244_);
  fill: #82A79C;
}

.st292 {
  clip-path: url(#SVGID_00000023259984310750606790000011203458178015815051_);
}

.st293 {
  clip-path: url(#SVGID_00000007422988561824091260000014183209377914743182_);
  fill: #EBEBE7;
}

.st294 {
  clip-path: url(#SVGID_00000050639409590113720280000006246842424237196450_);
}

.st295 {
  clip-path: url(#SVGID_00000089553011680202652100000009967802263673951908_);
  fill: #999A98;
}

.st296 {
  clip-path: url(#SVGID_00000168089125010939575920000003719609696690007735_);
}

.st297 {
  clip-path: url(#SVGID_00000096026360547580789880000016514487816508161452_);
  fill: #999A98;
}

.st298 {
  clip-path: url(#SVGID_00000169558945551455088090000004297154424176411580_);
}

.st299 {
  clip-path: url(#SVGID_00000015329869484882278350000012099816341274707887_);
  fill: #6B59A6;
}

.st300 {
  clip-path: url(#SVGID_00000054970905294074994240000008547023130223714732_);
}

.st301 {
  clip-path: url(#SVGID_00000019666575948517980510000012161720058184725683_);
  fill: #6B59A6;
}

.st302 {
  clip-path: url(#SVGID_00000130608880670945403150000000495197710440106426_);
}

.st303 {
  clip-path: url(#SVGID_00000051377796062767112210000004451640774887881114_);
  fill: #548D7A;
}

.st304 {
  clip-path: url(#SVGID_00000029009238111609014620000018281726990343021988_);
}

.st305 {
  clip-path: url(#SVGID_00000080907250712040136460000009414238805898004392_);
  fill: #4D8271;
}

.st306 {
  clip-path: url(#SVGID_00000062193399396930462800000017359777104875800751_);
}

.st307 {
  clip-path: url(#SVGID_00000080175811744734672460000003463589061613892510_);
  fill: #4A7F6F;
}

.st308 {
  clip-path: url(#SVGID_00000105392975602651808970000007345933847618165934_);
}

.st309 {
  clip-path: url(#SVGID_00000018239139281617801520000007842975572714688143_);
  fill: #4D8271;
}

.st310 {
  clip-path: url(#SVGID_00000085250362007295034060000001069503964711971518_);
}

.st311 {
  clip-path: url(#SVGID_00000034053328129590442970000002228345641125046950_);
  fill: #699687;
}

.st312 {
  clip-path: url(#SVGID_00000132057926914415416280000011816769838948620184_);
}

.st313 {
  clip-path: url(#SVGID_00000062899828591450205290000001701140550972385716_);
  fill: #C9DAD1;
}

.st314 {
  clip-path: url(#SVGID_00000007389794053931328640000012053285998875572397_);
}

.st315 {
  clip-path: url(#SVGID_00000124883714143811994430000004327115122697381306_);
  fill: #C9DAD1;
}

.st316 {
  clip-path: url(#SVGID_00000176021021522876065960000003493049428958716549_);
}

.st317 {
  clip-path: url(#SVGID_00000124845667453767239030000013899656822817152904_);
  fill: #C9DAD1;
}

.st318 {
  clip-path: url(#SVGID_00000069399463380841753360000016788419691048386957_);
}

.st319 {
  clip-path: url(#SVGID_00000005965628524665171130000000704854594344688520_);
  fill: #165748;
}

.st320 {
  clip-path: url(#SVGID_00000011004371721863142360000002816196277689403041_);
}

.st321 {
  clip-path: url(#SVGID_00000098925155040536478190000013604024749958158238_);
  fill: #165748;
}

.st322 {
  clip-path: url(#SVGID_00000034785634391087453230000016223623866739531447_);
}

.st323 {
  clip-path: url(#SVGID_00000181780810916512364020000002471643704355617931_);
  fill: #165748;
}

.st324 {
  clip-path: url(#SVGID_00000041995133862260354300000018092199046148434073_);
}

.st325 {
  clip-path: url(#SVGID_00000139292953447424529630000003883144587551331716_);
  fill: #165748;
}

.st326 {
  clip-path: url(#SVGID_00000075874230917260245070000000693260929788113804_);
}

.st327 {
  clip-path: url(#SVGID_00000108269037090248431010000015358791619761294012_);
  fill: #A4B6AD;
}

.st328 {
  clip-path: url(#SVGID_00000011734884826857821570000012797851105639138467_);
}

.st329 {
  clip-path: url(#SVGID_00000023269283599108529530000015532522682813582998_);
  fill: #A2B3AB;
}

.st330 {
  clip-path: url(#SVGID_00000160185669522256617530000003819437176481283203_);
}

.st331 {
  clip-path: url(#SVGID_00000080885336133050178290000002683424533991356336_);
  fill: #91B1A5;
}

.st332 {
  clip-path: url(#SVGID_00000146491860262719363520000013054718449282209211_);
}

.st333 {
  clip-path: url(#SVGID_00000079460059305562727980000011063014881268418702_);
  fill: #8BA79D;
}

.st334 {
  clip-path: url(#SVGID_00000114056693852682511720000002381382434742835104_);
}

.st335 {
  clip-path: url(#SVGID_00000021803248171550645280000004978567063190828730_);
  fill: #91B1A5;
}

.st336 {
  clip-path: url(#SVGID_00000170992240325329693090000002980734655741247915_);
}

.st337 {
  clip-path: url(#SVGID_00000063615139677745977410000008257398668642541191_);
  fill: #8BA79D;
}

.st338 {
  clip-path: url(#SVGID_00000001629739401705710290000017531237170477404858_);
}

.st339 {
  clip-path: url(#SVGID_00000156551311951291619080000007728161596039927210_);
  fill: #6E9084;
}

.st340 {
  clip-path: url(#SVGID_00000178201804692578697340000009234710212091566515_);
}

.st341 {
  clip-path: url(#SVGID_00000145018517356663159950000008269592147817861763_);
  fill: #165748;
}

.st342 {
  clip-path: url(#SVGID_00000097463553793257297450000002149428230545769629_);
}

.st343 {
  clip-path: url(#SVGID_00000008833138736417553140000004996644314667246268_);
  fill: #165748;
}

.st344 {
  clip-path: url(#SVGID_00000025439696028484789430000016835938165393494176_);
}

.st345 {
  clip-path: url(#SVGID_00000034074845264779712580000011691506479359356859_);
  fill: #EBEAE6;
}

.st346 {
  clip-path: url(#SVGID_00000051379125130512330530000006278500669265588113_);
}

.st347 {
  clip-path: url(#SVGID_00000079473633760766480410000002601932436968313474_);
  fill: #DCDDD7;
}

.st348 {
  clip-path: url(#SVGID_00000180331756575943787200000002886641179234032559_);
}

.st349 {
  clip-path: url(#SVGID_00000148648077906093733220000011492773015873407152_);
  fill: #868B89;
}

.st350 {
  clip-path: url(#SVGID_00000182519634550936659290000005225284703601412022_);
}

.st351 {
  clip-path: url(#SVGID_00000178923560730554788620000006631688316648092294_);
  fill: #DCDDD7;
}

.st352 {
  clip-path: url(#SVGID_00000017490377738034723840000005115579317643102903_);
}

.st353 {
  clip-path: url(#SVGID_00000090293460591894047820000011502476727491620540_);
  fill: #999C9A;
}

.st354 {
  clip-path: url(#SVGID_00000103265976855521794080000000030322867590889889_);
}

.st355 {
  clip-path: url(#SVGID_00000173130672958649530900000012126713597612689839_);
  fill: #999C9A;
}

.st356 {
  clip-path: url(#SVGID_00000038376929126189604910000004783315137069891260_);
}

.st357 {
  clip-path: url(#SVGID_00000070120617612663090410000010229747960125056944_);
  fill: #98CAB7;
}

.st358 {
  clip-path: url(#SVGID_00000071540835010902523940000014472356753261280388_);
}

.st359 {
  clip-path: url(#SVGID_00000021817993351275964630000017509837796556975252_);
  fill: #6E9A8A;
}

.st360 {
  clip-path: url(#SVGID_00000013891937524053713770000016242578235348854460_);
}

.st361 {
  clip-path: url(#SVGID_00000173853245973437240750000011739051331923188374_);
  fill: #6B59A6;
}

.st362 {
  clip-path: url(#SVGID_00000150824839455514106260000016549847904160599443_);
}

.st363 {
  clip-path: url(#SVGID_00000049909841849442412110000016262049537642542760_);
  fill: #699085;
}

.st364 {
  clip-path: url(#SVGID_00000141427429529925847830000013047752972864026783_);
}

.st365 {
  clip-path: url(#SVGID_00000043449293587972719780000012146910201623324603_);
  fill: #98CAB7;
}

.st366 {
  clip-path: url(#SVGID_00000125583324292174962540000018418491068633478544_);
}

.st367 {
  clip-path: url(#SVGID_00000005959582934734811840000004031420063868649915_);
  fill: #679384;
}

.st368 {
  clip-path: url(#SVGID_00000171717146168563749700000009468527165346619806_);
}

.st369 {
  clip-path: url(#SVGID_00000061451040646823076970000011044681893335972485_);
  fill: #6B59A6;
}

.st370 {
  clip-path: url(#SVGID_00000142155791336529222740000002973712490919419560_);
}

.st371 {
  clip-path: url(#SVGID_00000101795425277512464360000015868998589979948456_);
  fill: #6B59A6;
}

.st372 {
  clip-path: url(#SVGID_00000035509967378662739270000014603116705042947513_);
}

.st373 {
  clip-path: url(#SVGID_00000058554202154821323320000009955385263496460201_);
  fill: #6B59A6;
}

.st374 {
  clip-path: url(#SVGID_00000139275788918807082770000015151651360729509256_);
}

.st375 {
  clip-path: url(#SVGID_00000066495991366260715410000017571746470641118866_);
  fill: #6B59A6;
}

.st376 {
  clip-path: url(#SVGID_00000165923673789118675610000013744392502654707086_);
}

.st377 {
  clip-path: url(#SVGID_00000069367996037790668190000001889712648234809497_);
  fill: #547E6F;
}

.st378 {
  clip-path: url(#SVGID_00000152961644110951332330000009058123715589040530_);
}

.st379 {
  clip-path: url(#SVGID_00000129200563821389975250000001806944412825930142_);
  fill: #C7D9D0;
}

.st380 {
  clip-path: url(#SVGID_00000078012256678323923610000013347474298774848944_);
}

.st381 {
  clip-path: url(#SVGID_00000033364542103462035200000015127243001873041592_);
  fill: #C7D9D0;
}

.st382 {
  clip-path: url(#SVGID_00000183227610941748600090000012996104923368718009_);
}

.st383 {
  clip-path: url(#SVGID_00000162316728337395918020000011502685867910155953_);
  fill: #C7D9D0;
}

.st384 {
  fill: #E0E1DB;
}

.st385 {
  clip-path: url(#SVGID_00000056422708848950244260000009519132109481361801_);
}

.st386 {
  clip-path: url(#SVGID_00000117676171804241370390000004711734432240933041_);
  enable-background: new;
}

.st387 {
  clip-path: url(#SVGID_00000052799777498133681320000013363359146887765430_);
}

.st388 {
  clip-path: url(#SVGID_00000119817190039917496800000016097223251663753892_);
}

.st389 {
  opacity: 0;
  clip-path: url(#SVGID_00000033369213828253563370000018014598000429736117_);
}

.st390 {
  clip-path: url(#SVGID_00000003803090028254627260000013079622111064767137_);
}

.st391 {
  clip-path: url(#SVGID_00000078045588727003889920000003862320554603920782_);
}

.st392 {
  clip-path: url(#SVGID_00000170245789676248959930000003577759728019981968_);
  fill: #6B59A6;
}

.st393 {
  clip-path: url(#SVGID_00000101792023588712051900000005192625502780633526_);
}

.st394 {
  clip-path: url(#SVGID_00000160904603342416327950000005185947816577025193_);
  enable-background: new;
}

.st395 {
  clip-path: url(#SVGID_00000181069134374524668300000010783531849371844235_);
}

.st396 {
  clip-path: url(#SVGID_00000157299991014497513460000015088930152100984249_);
}

.st397 {
  opacity: 0;
  clip-path: url(#SVGID_00000009566359143860216130000000619502872525618064_);
}

.st398 {
  clip-path: url(#SVGID_00000096779405228097264810000011270931651877153449_);
}

.st399 {
  clip-path: url(#SVGID_00000091694140768530362050000006219384397461275804_);
}

.st400 {
  clip-path: url(#SVGID_00000034808219016059077660000018387096989973661842_);
  fill: #3E3F6F;
}

.st401 {
  opacity: 0.1;
}

.st402 {
  fill: #1F715C;
}

.st403 {
  fill: #A5B5BB;
}

.st404 {
  fill: #49BD99;
}

.st405 {
  fill: #2A2C2F;
}

.st406 {
  fill: #FFFFFF;
}

.st407 {
  fill: #434648;
}

.st408 {
  fill: #231F20;
}

.st409 {
  fill: #14604E;
}

.st410 {
  opacity: 0.8;
  fill: #2A2C2F;
}

.st411 {
  fill: #79AA9D;
}

.st412 {
  fill: url(#SVGID_00000154428061557785553310000007468840367558593440_);
}

.st413 {
  fill: #AFB4C4;
}

.st414 {
  fill: url(#SVGID_00000120527589392467667700000004184667357305927589_);
}

.st415 {
  fill: #EEF0F5;
}

.st416 {
  fill: #C8CEDB;
}

.st417 {
  enable-background: new;
}

.st418 {
  clip-path: url(#SVGID_00000034052073269625490400000002107134244204297633_);
  enable-background: new;
}

.st419 {
  fill: #0D3F33;
}

.st420 {
  clip-path: url(#SVGID_00000124873854720192893060000004104679844509810609_);
  enable-background: new;
}

.st421 {
  fill: #0A3229;
}

.st422 {
  fill: #115444;
}

.st423 {
  fill: #0A3027;
}

.st424 {
  clip-path: url(#SVGID_00000023255524766417908040000007554380251892502948_);
  enable-background: new;
}

.st425 {
  fill: #0C3A2F;
}

.st426 {
  fill: #0C3C30;
}

.st427 {
  fill: #0D3D32;
}

.st428 {
  fill: #0C382D;
}

.st429 {
  fill: #0B362C;
}

.st430 {
  fill: #0B342A;
}

.st431 {
  opacity: 0.7;
}

.st432 {
  clip-path: url(#SVGID_00000095327292671378373640000001368989439420678576_);
  enable-background: new;
}

.st433 {
  fill: #608E80;
}

.st434 {
  clip-path: url(#SVGID_00000077315283751534540170000014386546414210713494_);
  enable-background: new;
}

.st435 {
  fill: #588174;
}

.st436 {
  fill: #5B8578;
}

.st437 {
  fill: #5D8A7C;
}

.st438 {
  clip-path: url(#SVGID_00000183945318782702248310000015819262460101409944_);
  enable-background: new;
}

.st439 {
  fill: #557D71;
}

.st440 {
  fill: #52786D;
}

.st441 {
  fill: #4F7469;
}

.st442 {
  fill: #4C7065;
}

.st443 {
  clip-path: url(#SVGID_00000142862183632018885710000001919419964837617846_);
  enable-background: new;
}

.st444 {
  clip-path: url(#SVGID_00000111873762675510192000000006572089602193895851_);
  enable-background: new;
}

.st445 {
  clip-path: url(#SVGID_00000083802868918146004770000015554686170808304775_);
  enable-background: new;
}

.st446 {
  clip-path: url(#SVGID_00000000902825071871783980000005530729572743490977_);
  enable-background: new;
}

.st447 {
  clip-path: url(#SVGID_00000062186217845358196350000000731802043707450772_);
  enable-background: new;
}

.st448 {
  clip-path: url(#SVGID_00000065766957388358419890000014200738768900074673_);
  enable-background: new;
}

.st449 {
  clip-path: url(#SVGID_00000062888540730045273600000003109979808757939341_);
  enable-background: new;
}

.st450 {
  fill: #7FBCA9;
}

.st451 {
  clip-path: url(#SVGID_00000019676267472733944820000005393877211339483834_);
  enable-background: new;
}

.st452 {
  fill: #496C61;
}

.st453 {
  fill: #255F4D;
}

.st454 {
  clip-path: url(#SVGID_00000054246858162746615170000002308833728245094538_);
  enable-background: new;
}

.st455 {
  fill: #307D65;
}

.st456 {
  fill: #2F7962;
}

.st457 {
  fill: #2D755F;
}

.st458 {
  clip-path: url(#SVGID_00000144329767119060251330000005995803561084216249_);
  enable-background: new;
}

.st459 {
  fill: #266250;
}

.st460 {
  fill: #276653;
}

.st461 {
  fill: #296A56;
}

.st462 {
  fill: #2A6E59;
}

.st463 {
  fill: #2C715C;
}

.st464 {
  fill: #40A586;
}

.st465 {
  clip-path: url(#SVGID_00000167377982244173228620000008672155110150577028_);
  enable-background: new;
}

.st466 {
  clip-path: url(#SVGID_00000150820140067373963030000004527476208545431200_);
  enable-background: new;
}

.st467 {
  clip-path: url(#SVGID_00000142140069147179920210000001965461679249093020_);
  enable-background: new;
}

.st468 {
  clip-path: url(#SVGID_00000060726614974085317030000002534942499584772251_);
  enable-background: new;
}

.st469 {
  clip-path: url(#SVGID_00000131344720603012463890000016440446183133574054_);
  enable-background: new;
}

.st470 {
  clip-path: url(#SVGID_00000135664741377288984710000014531009630837420477_);
  enable-background: new;
}

.st471 {
  clip-path: url(#SVGID_00000021799861237827729900000001312021061623070896_);
  enable-background: new;
}

.st472 {
  clip-path: url(#SVGID_00000054251999544152880380000003685900415000742293_);
  enable-background: new;
}

.st473 {
  clip-path: url(#SVGID_00000083804833378118104590000011973076396359091901_);
  enable-background: new;
}

.st474 {
  clip-path: url(#SVGID_00000117674726942156735340000013124240659067329664_);
  enable-background: new;
}

.st475 {
  fill: #33836A;
}

.st476 {
  fill: url(#SVGID_00000052102092478126871330000010068315660973033882_);
}

.st477 {
  fill: url(#SVGID_00000062160092806344078610000002958462874500973704_);
}

.st478 {
  fill: url(#SVGID_00000080927730880808870360000010494179345072507021_);
}

.st479 {
  fill: url(#SVGID_00000039840614511233797320000015488837980909533853_);
}

.st480 {
  fill: url(#SVGID_00000160886997902263448120000005159213642681593520_);
}

.st481 {
  fill: url(#SVGID_00000044135821400543180440000013658168368525714109_);
}

.st482 {
  fill: url(#SVGID_00000043416589715755144840000012955015024768489114_);
}

.st483 {
  fill: url(#SVGID_00000094583957196676340270000010963878498506072731_);
}

.st484 {
  fill: url(#SVGID_00000057147162464462509360000007384895010933757608_);
}

.st485 {
  fill: url(#SVGID_00000067915485182464578150000013954615185281438080_);
}

.st486 {
  fill: url(#SVGID_00000168809827890006621100000006086487081702375590_);
}

.st487 {
  fill: url(#SVGID_00000020366878624461613910000013462214431090929843_);
}

.st488 {
  fill: url(#SVGID_00000102504218680748575780000004685990213173527219_);
}

.st489 {
  fill: url(#SVGID_00000008871893698604312630000006107565501061311423_);
}

.st490 {
  fill: url(#SVGID_00000103964708114562574910000006293784943950366374_);
}

.st491 {
  fill: url(#SVGID_00000168822254770390568550000009429257863744148383_);
}

.st492 {
  fill: url(#SVGID_00000177481621834225864880000012732341878437097884_);
}

.st493 {
  fill: url(#SVGID_00000161616279485740502890000004385462366772098962_);
}

.st494 {
  fill: url(#SVGID_00000173145600738565429030000015017733978824567711_);
}

.st495 {
  fill: url(#SVGID_00000125584405455845400210000010571586102552015017_);
}

.st496 {
  fill: url(#SVGID_00000170979326490042957460000014319934628893275577_);
}

.st497 {
  fill: url(#SVGID_00000106140217228035938670000008672326762687391925_);
}

.st498 {
  fill: url(#SVGID_00000011012497981469723970000015089638533241625267_);
}

.st499 {
  fill: url(#SVGID_00000079479919211837410070000006725124497746002603_);
}

.st500 {
  fill: url(#SVGID_00000118367665835962864440000003548276300151932074_);
}

.st501 {
  fill: url(#SVGID_00000031179512896890390240000012361250043217446545_);
}

.st502 {
  fill: url(#SVGID_00000023282792851669715130000003663453190071168953_);
}

.st503 {
  fill: url(#SVGID_00000011729607814891679370000004804393636560378786_);
}

.st504 {
  fill: url(#SVGID_00000078744429205005111360000010399616580868337060_);
}

.st505 {
  fill: url(#SVGID_00000167367539943859570800000002847009078433680547_);
}

.st506 {
  fill: url(#SVGID_00000116196276862113362020000012420429782089057190_);
}

.st507 {
  fill: url(#SVGID_00000016065064191720767950000011895556750801450912_);
}

.st508 {
  fill: url(#SVGID_00000132775220311646892080000011581319972395656083_);
}

.st509 {
  fill: url(#SVGID_00000150806962579735459140000013682949499410853284_);
}

.st510 {
  fill: url(#SVGID_00000037678739412225794280000010890381032232289199_);
}

.st511 {
  fill: url(#SVGID_00000168074472589956283300000008685653176658995349_);
}

.st512 {
  fill: url(#SVGID_00000060711017622225161540000016591035313416590259_);
}

.st513 {
  fill: url(#SVGID_00000090288638710218444520000009526594484952825482_);
}

.st514 {
  fill: url(#SVGID_00000011733832417536843450000004084141390241641354_);
}

.st515 {
  fill: url(#SVGID_00000142170867560162437100000000305072714222909335_);
}

.st516 {
  fill: url(#SVGID_00000044873357448810800280000018437016924494166930_);
}

.st517 {
  fill: url(#SVGID_00000023260849113935224550000012522872674479741365_);
}

.st518 {
  fill: url(#SVGID_00000063597520365952827020000004859801190466845629_);
}

.st519 {
  fill: url(#SVGID_00000132773097469006931240000002332384251060274843_);
}

.st520 {
  fill: url(#SVGID_00000127028691916203770400000018083763193846755752_);
}

.st521 {
  fill: url(#SVGID_00000111171370923392250630000006713151686779103886_);
}

.st522 {
  fill: url(#SVGID_00000011029885320051244700000016171753550287336612_);
}

.st523 {
  fill: url(#SVGID_00000010300255328602137690000011475816195480093070_);
}

.st524 {
  fill: url(#SVGID_00000128455513144513690740000011970167391708047542_);
}

.st525 {
  fill: url(#SVGID_00000081606831213873268520000002804494245852016052_);
}

.st526 {
  fill: url(#SVGID_00000041273800021093853770000017875703796493847944_);
}

.st527 {
  fill: url(#SVGID_00000092434500865566406170000010000908042508328070_);
}

.st528 {
  fill: url(#SVGID_00000180342811360001596890000012947352930024627895_);
}

.st529 {
  fill: url(#SVGID_00000039850380162841507920000010929709196783977900_);
}

.st530 {
  fill: url(#SVGID_00000178174827806540989460000003552921694982294929_);
}

.st531 {
  fill: url(#SVGID_00000039856362747783402820000006565014265997586586_);
}

.st532 {
  fill: url(#SVGID_00000155831758260373649290000007562343142398953864_);
}

.st533 {
  fill: url(#SVGID_00000170996919106897770590000011190550519760067775_);
}

.st534 {
  fill: url(#SVGID_00000067212318030067195950000010283256803724154279_);
}

.st535 {
  fill: url(#SVGID_00000183225541247524704230000016136861802007327381_);
}

.st536 {
  fill: url(#SVGID_00000055694891176725988110000001757792534257760650_);
}

.st537 {
  fill: url(#SVGID_00000134239190011441111590000012091214638070823083_);
}

.st538 {
  fill: url(#SVGID_00000152976643668489040720000004615265450674612927_);
}

.st539 {
  fill: url(#SVGID_00000016763816939953380480000007456472829624417694_);
}

.st540 {
  fill: url(#SVGID_00000175324915962714875230000013978330078293935274_);
}

.st541 {
  fill: url(#SVGID_00000035509431940065815910000011783441246193572760_);
}

.st542 {
  fill: url(#SVGID_00000052784120844084808850000018259499637882920361_);
}

.st543 {
  fill: url(#SVGID_00000098202390404565825070000003560081985062304134_);
}

.st544 {
  fill: url(#SVGID_00000080174249868880534020000017508566340176877207_);
}

.st545 {
  fill: url(#SVGID_00000035528677119873754690000018268767176573031042_);
}

.st546 {
  fill: url(#SVGID_00000057146445102732194840000015273372679954825134_);
}

.st547 {
  fill: url(#SVGID_00000093175973698811039610000011543212688242970008_);
}

.st548 {
  fill: url(#SVGID_00000132769566710564955140000007924011070935375805_);
}

.st549 {
  fill: url(#SVGID_00000173155559779900475400000014894447724999263660_);
}

.st550 {
  fill: url(#SVGID_00000071559341590184358600000014295363223752906906_);
}

.st551 {
  fill: url(#SVGID_00000112624368112499713240000010369630239594157477_);
}

.st552 {
  fill: url(#SVGID_00000137131014887784298130000009477142558203647401_);
}

.st553 {
  fill: url(#SVGID_00000058581225294047900240000016589556000848501410_);
}

.st554 {
  fill: url(#SVGID_00000155137334656113985490000011560222567413854371_);
}

.st555 {
  fill: url(#SVGID_00000064330663144529952980000014248646600895410084_);
}

.st556 {
  fill: url(#SVGID_00000168110079859695321290000004121386035464971183_);
}

.st557 {
  fill: url(#SVGID_00000116218253962607562580000009458723860493347467_);
}

.st558 {
  fill: url(#SVGID_00000150095475068993705770000016839849441056106915_);
}

.st559 {
  opacity: 0.2;
}

.st560 {
  opacity: 9.090909e-02;
}

.st561 {
  opacity: 0.1818;
}

.st562 {
  opacity: 0.2727;
}

.st563 {
  opacity: 0.3636;
}

.st564 {
  opacity: 0.4545;
}

.st565 {
  opacity: 0.5455;
}

.st566 {
  opacity: 0.6364;
}

.st567 {
  opacity: 0.7273;
}

.st568 {
  opacity: 0.8182;
}

.st569 {
  opacity: 0.9091;
}

.st570 {
  fill: url(#SVGID_00000139255163386790290130000006069313287115070610_);
}

.st571 {
  fill: url(#SVGID_00000134938178857253899150000005640380129690358435_);
}

.st572 {
  fill: url(#SVGID_00000049195674618552777960000008933469102735235474_);
}

.st573 {
  fill: url(#SVGID_00000080899886342298424980000018399678034749053068_);
}

.st574 {
  fill: url(#SVGID_00000031910902513267312760000017357407350596754873_);
}

.st575 {
  fill: #619788;
}

.st576 {
  fill: url(#SVGID_00000065058289078602078650000005236714892832637832_);
}

.st577 {
  fill: url(#SVGID_00000030466554239361056120000008844675951244749698_);
}

.st578 {
  fill: url(#SVGID_00000138557698457940115760000008114666567744523651_);
}

.st579 {
  fill: url(#SVGID_00000051378097318211331750000001413159093423802785_);
}

.st580 {
  fill: url(#SVGID_00000093155229912513179430000006909666807877301183_);
}

.st581 {
  fill: url(#SVGID_00000176722791029698829190000005095345499659123391_);
}

.st582 {
  fill: url(#SVGID_00000158751784126955304180000005769277842918812809_);
}

.st583 {
  fill: url(#SVGID_00000034088944159768189130000003686173997286528652_);
}

.st584 {
  fill: url(#SVGID_00000025426855269529679390000009775318558674063759_);
}

.st585 {
  fill: url(#SVGID_00000009575958678325834380000008287145356109189055_);
}

.st586 {
  opacity: 0.6;
  fill: #6B59A6;
}

.st587 {
  fill: url(#SVGID_00000072260569162786444760000017819178674254551698_);
}

.st588 {
  opacity: 0;
  fill: url(#SVGID_00000075138723883149918660000009424269538100255120_);
}

.st589 {
  opacity: 9.090909e-02;
  fill: url(#SVGID_00000116956091643489375810000004853145834609801919_);
}

.st590 {
  opacity: 0.1818;
  fill: url(#SVGID_00000167368432454752486850000015050465167556657333_);
}

.st591 {
  opacity: 0.2727;
  fill: url(#SVGID_00000125567906558664462690000001864516266154940297_);
}

.st592 {
  opacity: 0.3636;
  fill: url(#SVGID_00000019680669600589832690000003006449484576218810_);
}

.st593 {
  opacity: 0.4545;
  fill: url(#SVGID_00000032606939584688029990000015067472852500232077_);
}

.st594 {
  opacity: 0.5455;
  fill: url(#SVGID_00000024697296607411920200000000189597004231084961_);
}

.st595 {
  opacity: 0.6364;
  fill: url(#SVGID_00000160185447634708869420000005593147588262240434_);
}

.st596 {
  opacity: 0.7273;
  fill: url(#SVGID_00000170261824760059610210000012267767040178674587_);
}

.st597 {
  opacity: 0.8182;
  fill: url(#SVGID_00000099660994963316915070000012115386431702592394_);
}

.st598 {
  opacity: 0.9091;
  fill: url(#SVGID_00000147186164661302860410000011050313868258564023_);
}

.st599 {
  fill: url(#SVGID_00000143581350793861916840000008830148331153437846_);
}

.st600 {
  opacity: 0.7;
  fill: url(#SVGID_00000059991539951280531750000013391017327711520948_);
}

.st601 {
  opacity: 0.1;
  fill: url(#SVGID_00000087399387783652340470000001957036472394387868_);
}

.st602 {
  fill: url(#SVGID_00000013913132250064340940000009836835408761904784_);
}

.st603 {
  opacity: 0.5;
  fill: #2A2C2F;
}

.st604 {
  fill: url(#SVGID_00000160153420709400340670000015261966725395044252_);
}

.st605 {
  fill: #45494B;
}

.st606 {
  fill: #363B3D;
}

.st607 {
  fill: #5A5F60;
}

.st608 {
  fill: #35896F;
}

.st609 {
  clip-path: url(#SVGID_00000005969115398860949960000008200899918170690716_);
  enable-background: new;
}

.st610 {
  fill: #328168;
}

.st611 {
  fill: #33846B;
}

.st612 {
  fill: #35886E;
}

.st613 {
  fill: #368C71;
}

.st614 {
  fill: #379074;
}

.st615 {
  fill: #399377;
}

.st616 {
  fill: #3A977A;
}

.st617 {
  fill: #3C9B7D;
}

.st618 {
  fill: #3D9F81;
}

.st619 {
  fill: #3FA384;
}

.st620 {
  fill: #40A687;
}

.st621 {
  fill: #42AA8A;
}

.st622 {
  fill: #43AE8D;
}

.st623 {
  fill: #45B290;
}

.st624 {
  fill: #46B593;
}

.st625 {
  fill: #48B996;
}

.st626 {
  clip-path: url(#SVGID_00000183248247882148052780000006816087414874121134_);
  enable-background: new;
}

.st627 {
  clip-path: url(#SVGID_00000180334396871357423110000000766381196765300140_);
  enable-background: new;
}

.st628 {
  clip-path: url(#SVGID_00000170985741913385340200000016717418211286551186_);
  enable-background: new;
}

.st629 {
  clip-path: url(#SVGID_00000060016738335523004130000015008599216893223055_);
  enable-background: new;
}

.st630 {
  fill: #3EA081;
}

.st631 {
  clip-path: url(#SVGID_00000073719956614512952430000018232782692234089109_);
  enable-background: new;
}

.st632 {
  clip-path: url(#SVGID_00000077319103481115034590000002165909715647443357_);
  enable-background: new;
}

.st633 {
  clip-path: url(#SVGID_00000090293331435139569780000005447776457870225812_);
  enable-background: new;
}

.st634 {
  clip-path: url(#SVGID_00000121976796875270178780000010880477186425953192_);
  enable-background: new;
}

.st635 {
  clip-path: url(#SVGID_00000090986822355014862340000017644161427109360522_);
  enable-background: new;
}

.st636 {
  clip-path: url(#SVGID_00000062877515031552564130000014882635771280240779_);
  enable-background: new;
}

.st637 {
  clip-path: url(#SVGID_00000052090708638805822860000016054557030302964100_);
  enable-background: new;
}

.st638 {
  clip-path: url(#SVGID_00000162324190457917756970000012475429157221878961_);
  enable-background: new;
}

.st639 {
  fill: #3E9F81;
}

.st640 {
  fill: #2B715B;
}

.st641 {
  fill: #3D9E80;
}

.st642 {
  fill: #44B08E;
}

.st643 {
  clip-path: url(#SVGID_00000044862395640064716850000014788548540039123126_);
  enable-background: new;
}

.st644 {
  fill: #858585;
}

.st645 {
  fill: #8A8A8A;
}

.st646 {
  fill: #8F8F8F;
}

.st647 {
  fill: #949494;
}

.st648 {
  fill: #999999;
}

.st649 {
  fill: #9E9E9E;
}

.st650 {
  fill: #A3A3A3;
}

.st651 {
  fill: #A8A8A8;
}

.st652 {
  fill: #ADADAD;
}

.st653 {
  fill: #B3B3B3;
}

.st654 {
  fill: #B8B8B8;
}

.st655 {
  fill: #BDBDBD;
}

.st656 {
  fill: #C2C2C2;
}

.st657 {
  fill: #C7C7C7;
}

.st658 {
  fill: #CCCCCC;
}

.st659 {
  fill: #D1D1D1;
}

.st660 {
  fill: #D6D6D6;
}

.st661 {
  fill: #DBDBDB;
}

.st662 {
  fill: #E0E0E0;
}

.st663 {
  fill: #E6E6E6;
}

.st664 {
  fill: #EBEBEB;
}

.st665 {
  fill: #F0F0F0;
}

.st666 {
  fill: #F5F5F5;
}

.st667 {
  fill: #FAFAFA;
}

.st668 {
  clip-path: url(#SVGID_00000148624742135125230500000015448686342994909314_);
  enable-background: new;
}

.st669 {
  clip-path: url(#SVGID_00000155867475234395305540000017463433726966044825_);
  enable-background: new;
}

.st670 {
  clip-path: url(#SVGID_00000147943020267546529910000012732040868724686506_);
  enable-background: new;
}

.st671 {
  fill: #989898;
}

.st672 {
  clip-path: url(#SVGID_00000102540574749923340030000008936213158419185852_);
  enable-background: new;
}

.st673 {
  clip-path: url(#SVGID_00000141436687630599705100000013976773822635687833_);
  enable-background: new;
}

.st674 {
  fill: #D8D8D8;
}

.st675 {
  clip-path: url(#SVGID_00000149356215885464585560000011881128028133847964_);
  enable-background: new;
}

.st676 {
  clip-path: url(#SVGID_00000106126347260519404240000017653387365879695272_);
  enable-background: new;
}

.st677 {
  clip-path: url(#SVGID_00000011024264156551330430000015445240320913325712_);
  enable-background: new;
}

.st678 {
  clip-path: url(#SVGID_00000139999317555025514560000007514632665172832932_);
  enable-background: new;
}

.st679 {
  clip-path: url(#SVGID_00000176760613270208596390000000679961356124511118_);
  enable-background: new;
}

.st680 {
  clip-path: url(#SVGID_00000035521351159681604860000011823307284901310375_);
  enable-background: new;
}

.st681 {
  clip-path: url(#SVGID_00000158743421654596645230000017403310955525133475_);
  enable-background: new;
}

.st682 {
  clip-path: url(#SVGID_00000083799331339326892820000018364758764869835667_);
  enable-background: new;
}

.st683 {
  clip-path: url(#SVGID_00000124152452547813372200000002239581705801053096_);
  enable-background: new;
}

.st684 {
  clip-path: url(#SVGID_00000103975549371510274510000015407527655117807780_);
  enable-background: new;
}

.st685 {
  clip-path: url(#SVGID_00000164500023634440531350000008044341609185411981_);
  enable-background: new;
}

.st686 {
  clip-path: url(#SVGID_00000065786061204837593570000005781357673529297830_);
  enable-background: new;
}

.st687 {
  clip-path: url(#SVGID_00000161632120848479886380000003733691173523393174_);
  enable-background: new;
}

.st688 {
  clip-path: url(#SVGID_00000058580712698498205800000002343681672614021040_);
  enable-background: new;
}

.st689 {
  clip-path: url(#SVGID_00000061436686723705347590000004415638639944306305_);
  enable-background: new;
}

.st690 {
  clip-path: url(#SVGID_00000181086623920119417690000008356040696170318226_);
  enable-background: new;
}

.st691 {
  clip-path: url(#SVGID_00000029034403661696805590000013705629917149893522_);
  enable-background: new;
}

.st692 {
  clip-path: url(#SVGID_00000064314538917625302870000010617398789527074726_);
  enable-background: new;
}

.st693 {
  fill: #685AA1;
}

.st694 {
  fill: url(#XMLID_00000177445264036837408360000011364557094033990843_);
}

.st695 {
  fill: url(#XMLID_00000002357051486091872420000010437553588764901258_);
}

.st696 {
  fill: url(#XMLID_00000071560257243230221320000012006169672960919709_);
}

.st697 {
  fill: #F1F0F0;
}

.st698 {
  fill: url(#SVGID_00000052105558426567873700000011146227507210112683_);
}

.st699 {
  opacity: 0.8;
  fill: #455B64;
}

.st700 {
  fill: url(#SVGID_00000157300515780051781880000015561922388114996642_);
}

.st701 {
  fill: #3E3F6F;
}

.st702 {
  fill: #6B59A6;
}

.st703 {
  fill: #FAFBFB;
}

.st704 {
  fill: #58C2B1;
}

.st705 {
  opacity: 0.8;
  fill: #FAFBFB;
}

.st706 {
  fill: #455B64;
}

.st707 {
  opacity: 0.3;
}

.st708 {
  fill: #716F6F;
}

.st709 {
  fill: #C6C5C4;
}

.st710 {
  fill: url(#SVGID_00000001642279757092043550000000620061809745703352_);
}

.st711 {
  fill: #049AD0;
}

.st712 {
  fill: url(#SVGID_00000136406542164755554190000016916854986678122921_);
}

.st713 {
  fill: url(#SVGID_00000171695094999744222730000009741998786566924941_);
}

.st714 {
  fill: url(#SVGID_00000034071860952875091280000010631009594429895843_);
}

.st715 {
  fill: url(#SVGID_00000114046833621738871990000006631435185182373025_);
}

.st716 {
  fill: url(#SVGID_00000035502761772787327930000006755143401827611526_);
}

.st717 {
  fill: #1B6F5A;
}

.st718 {
  fill: #A382BB;
}

.st719 {
  opacity: 0.7;
  fill: #4ABD96;
}

.st720 {
  opacity: 0.6;
  fill: #1B6F5A;
}

.st721 {
  fill: url(#SVGID_00000169540739672995897960000000865428878484433579_);
}

.st722 {
  fill: url(#SVGID_00000010994030568172592540000007268276080122722743_);
}

.st723 {
  fill: url(#SVGID_00000070818859078289481980000005486004182422998691_);
}

.st724 {
  fill: url(#SVGID_00000170997383464867394240000014562288232052467364_);
}

.st725 {
  fill: url(#SVGID_00000101802947505672007180000012112010127509605253_);
}

.st726 {
  fill: url(#SVGID_00000114752767594748814820000002454213992501460864_);
}

.st727 {
  fill: #30B78D;
}

.st728 {
  fill: #F16C73;
}

.st729 {
  fill: #FDD500;
}

.st730 {
  opacity: 0.2;
  fill: #6B59A6;
}

.st731 {
  fill: url(#SVGID_00000000936045561995213270000000436573747539905976_);
}

.st732 {
  fill: url(#SVGID_00000014636069807331990530000016464885929403835828_);
}

.st733 {
  fill: url(#SVGID_00000070824313567713376030000017366612356728772787_);
}

.st734 {
  fill: url(#SVGID_00000018917882513385721030000003753547977937880462_);
}

.st735 {
  fill: url(#SVGID_00000165955482791434183330000002956205166861875868_);
}

.st736 {
  fill: url(#SVGID_00000153701489203553502020000008667612147392153006_);
}

.st737 {
  fill: #1F6F58;
}

.st738 {
  fill: url(#SVGID_00000019668098384134674340000015050915831204207033_);
}

.st739 {
  fill: url(#SVGID_00000059987957584343416160000010141606937596254380_);
}

.st740 {
  fill: url(#SVGID_00000091701630427405840670000008178964960988086924_);
}

.st741 {
  fill: url(#SVGID_00000002383455051978391970000015046688762010616732_);
}

.st742 {
  fill: url(#SVGID_00000101090146117231066020000015213724549027498671_);
}

.st743 {
  fill: url(#SVGID_00000118381053504427637810000010089043134576385454_);
}

.st744 {
  fill: #4ABD96;
}

.st745 {
  opacity: 0.1;
  fill: #4ABD96;
}

.st746 {
  opacity: 0.5;
}

.st747 {
  fill: url(#SVGID_00000065038443111654446140000004837020373823728538_);
}

.st748 {
  fill: url(#SVGID_00000119809779406624339660000014671118884235607186_);
}

.st749 {
  fill: url(#SVGID_00000097475096515846580150000013103256944970991548_);
}

.st750 {
  fill: #30302F;
}

.st751 {
  fill: url(#SVGID_00000094611857394695604230000017554351468737833617_);
}

.st752 {
  fill: url(#SVGID_00000031903336087633081750000004325500638879294108_);
}

.st753 {
  fill: url(#SVGID_00000026161098892319643720000005012715970310131588_);
}

.st754 {
  fill: url(#SVGID_00000030447426108637226660000013085928836938748834_);
}

.st755 {
  fill: url(#SVGID_00000083078146372506666450000015476859294298995371_);
}

.st756 {
  fill: url(#SVGID_00000052804522418020718630000007367017659461867661_);
}

.st757 {
  opacity: 0.5;
  fill: #FFFFFF;
}

.st758 {
  fill: url(#SVGID_00000036940828919819977360000012222451166860970134_);
}

.st759 {
  clip-path: url(#SVGID_00000118376999367980211530000002178723036925770920_);
}

.st760 {
  clip-path: url(#SVGID_00000005972322321440149700000007000295395471515057_);
  fill: #25292A;
}

.st761 {
  clip-path: url(#SVGID_00000109718592301390624480000004082256326148240518_);
}

.st762 {
  clip-path: url(#SVGID_00000133505593950958482340000010609617159676474815_);
  fill: #25292A;
}

.st763 {
  clip-path: url(#SVGID_00000044159265557266630730000001702816379873596319_);
}

.st764 {
  clip-path: url(#SVGID_00000057111477722313882220000018244533634243482013_);
  fill: #25292A;
}

.st765 {
  clip-path: url(#SVGID_00000057144952522453762540000010958679374675045017_);
}

.st766 {
  clip-path: url(#SVGID_00000026140804858608778730000005100528770464823981_);
  fill: #E0E1DB;
}

.st767 {
  clip-path: url(#SVGID_00000120547738955317501460000002823264911005993916_);
}

.st768 {
  clip-path: url(#SVGID_00000031917498302374734070000012530835126974842795_);
  fill: #25292A;
}

.st769 {
  clip-path: url(#SVGID_00000128455637404106665100000006953646123873865116_);
}

.st770 {
  clip-path: url(#SVGID_00000010300733861166955580000015024290261762069910_);
  fill: #25292A;
}

.st771 {
  fill: #266B70;
}

.st772 {
  fill: #F7F4F3;
}

.st773 {
  fill: #80B0DE;
}

.st774 {
  opacity: 0.1;
  fill: #6B59A6;
}

.st775 {
  fill: #221F20;
}

.st776 {
  fill: url(#SVGID_00000098185236971236811610000012444489754103515828_);
}

.st777 {
  fill: url(#SVGID_00000182528582766458823090000009571882965699377062_);
}

.st778 {
  fill: url(#SVGID_00000066473155673772559230000017704056415551227283_);
}

.st779 {
  fill: url(#SVGID_00000128475795135487084050000017033960793608523681_);
}

.st780 {
  opacity: 0.4;
  fill: #A0A7AC;
}

.st781 {
  opacity: 0.7;
  fill: #C8C1CE;
}

.st782 {
  fill: #468FCD;
}

.st783 {
  fill: #F2F2F2;
}

.st784 {
  opacity: 0.9;
  fill: #FFF8ED;
}

.st785 {
  fill: #FFF8ED;
}

.st786 {
  fill: url(#SVGID_00000096781760508972647200000002867377843077115290_);
}

.st787 {
  fill: #E8E4E4;
}

.st788 {
  fill: url(#SVGID_00000070805496324265852330000015990522926281463193_);
}

.st789 {
  opacity: 0.3;
  fill: #49BD99;
}

.st790 {
  fill: url(#SVGID_00000121998911008753767570000002449269794594503352_);
}
</style>